import React from "react";
import { CheckCircle, Home } from "lucide-react";
import { useNavigate } from "react-router-dom";
const Success = () => {
  const navigate = useNavigate();
  const goHome = () =>{
    navigate("/my-policy");
  }
  return (
    <div className="flex justify-center items-center min-h-screen">
      <div className=" p-6 rounded-xl text-center w-full max-w-md bg-gray-100">
        <div className="flex  mb-4">
          <svg
            width="54"
            height="54"
            viewBox="0 0 54 54"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M27 0.333344C12.28 0.333344 0.333313 12.28 0.333313 27C0.333313 41.72 12.28 53.6667 27 53.6667C41.72 53.6667 53.6666 41.72 53.6666 27C53.6666 12.28 41.72 0.333344 27 0.333344ZM21.6666 40.3333L8.33331 27L12.0933 23.24L21.6666 32.7867L41.9066 12.5467L45.6666 16.3333L21.6666 40.3333Z"
              fill="#119C2B"
            />
          </svg>
        </div>

        <h2 className="text-xl font-semibold mb-2 text-left">You're all set!</h2>
        <p className="text-gray-600 mb-4 text-left">
          Your Solidarity Drive Program is now active. Start driving safe, earn
          points, and redeem awesome rewards.
        </p>

        <div className="flex  mb-4 ">
          <svg
            width="204"
            height="204"
            viewBox="0 0 204 204"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="1.2"
              y="1.2"
              width="201.6"
              height="201.6"
              rx="16.8"
              fill="white"
            />
            <rect
              x="1.2"
              y="1.2"
              width="201.6"
              height="201.6"
              rx="16.8"
              stroke="#D5DADD"
              stroke-width="1.6"
            />
            <path
              d="M62.8848 19.9237C62.8848 18.8613 62.0235 18 60.9611 18C59.8987 18 59.0375 18.8613 59.0375 19.9237C59.0375 20.9861 59.8987 21.8473 60.9611 21.8473C62.0235 21.8473 62.8848 20.9861 62.8848 19.9237Z"
              fill="#005574"
            />
            <path
              d="M73.1442 19.9237C73.1442 18.8613 72.2829 18 71.2205 18C70.1581 18 69.2969 18.8613 69.2969 19.9237C69.2969 20.9861 70.1581 21.8473 71.2205 21.8473C72.2829 21.8473 73.1442 20.9861 73.1442 19.9237Z"
              fill="#005574"
            />
            <path
              d="M83.4043 19.9237C83.4043 18.8613 82.5431 18 81.4807 18C80.4183 18 79.557 18.8613 79.557 19.9237C79.557 20.9861 80.4183 21.8473 81.4807 21.8473C82.5431 21.8473 83.4043 20.9861 83.4043 19.9237Z"
              fill="#005574"
            />
            <path
              d="M114.182 19.9237C114.182 18.8613 113.321 18 112.259 18C111.196 18 110.335 18.8613 110.335 19.9237C110.335 20.9861 111.196 21.8473 112.259 21.8473C113.321 21.8473 114.182 20.9861 114.182 19.9237Z"
              fill="#005574"
            />
            <path
              d="M129.572 19.9237C129.572 18.8613 128.71 18 127.648 18C126.586 18 125.724 18.8613 125.724 19.9237C125.724 20.9861 126.586 21.8473 127.648 21.8473C128.71 21.8473 129.572 20.9861 129.572 19.9237Z"
              fill="#005574"
            />
            <path
              d="M139.832 19.9237C139.832 18.8613 138.97 18 137.908 18C136.846 18 135.984 18.8613 135.984 19.9237C135.984 20.9861 136.846 21.8473 137.908 21.8473C138.97 21.8473 139.832 20.9861 139.832 19.9237Z"
              fill="#005574"
            />
            <path
              d="M144.962 19.9237C144.962 18.8613 144.101 18 143.038 18C141.976 18 141.114 18.8613 141.114 19.9237C141.114 20.9861 141.976 21.8473 143.038 21.8473C144.101 21.8473 144.962 20.9861 144.962 19.9237Z"
              fill="#005574"
            />
            <path
              d="M62.8848 25.0518C62.8848 23.9894 62.0235 23.1281 60.9611 23.1281C59.8987 23.1281 59.0375 23.9894 59.0375 25.0518C59.0375 26.1142 59.8987 26.9755 60.9611 26.9755C62.0235 26.9755 62.8848 26.1142 62.8848 25.0518Z"
              fill="#005574"
            />
            <path
              d="M68.0153 25.0518C68.0153 23.9894 67.154 23.1281 66.0916 23.1281C65.0292 23.1281 64.168 23.9894 64.168 25.0518C64.168 26.1142 65.0292 26.9755 66.0916 26.9755C67.154 26.9755 68.0153 26.1142 68.0153 25.0518Z"
              fill="#005574"
            />
            <path
              d="M78.2747 25.0518C78.2747 23.9894 77.4134 23.1281 76.351 23.1281C75.2886 23.1281 74.4274 23.9894 74.4274 25.0518C74.4274 26.1142 75.2886 26.9755 76.351 26.9755C77.4134 26.9755 78.2747 26.1142 78.2747 25.0518Z"
              fill="#005574"
            />
            <path
              d="M83.4043 25.0518C83.4043 23.9894 82.5431 23.1281 81.4807 23.1281C80.4183 23.1281 79.557 23.9894 79.557 25.0518C79.557 26.1142 80.4183 26.9755 81.4807 26.9755C82.5431 26.9755 83.4043 26.1142 83.4043 25.0518Z"
              fill="#005574"
            />
            <path
              d="M88.534 25.0518C88.534 23.9894 87.6728 23.1281 86.6104 23.1281C85.548 23.1281 84.6867 23.9894 84.6867 25.0518C84.6867 26.1142 85.548 26.9755 86.6104 26.9755C87.6728 26.9755 88.534 26.1142 88.534 25.0518Z"
              fill="#005574"
            />
            <path
              d="M98.7942 25.0518C98.7942 23.9894 97.933 23.1281 96.8706 23.1281C95.8082 23.1281 94.9469 23.9894 94.9469 25.0518C94.9469 26.1142 95.8082 26.9755 96.8706 26.9755C97.933 26.9755 98.7942 26.1142 98.7942 25.0518Z"
              fill="#005574"
            />
            <path
              d="M119.312 25.0518C119.312 23.9894 118.451 23.1281 117.389 23.1281C116.326 23.1281 115.465 23.9894 115.465 25.0518C115.465 26.1142 116.326 26.9755 117.389 26.9755C118.451 26.9755 119.312 26.1142 119.312 25.0518Z"
              fill="#005574"
            />
            <path
              d="M144.962 25.0518C144.962 23.9894 144.101 23.1281 143.038 23.1281C141.976 23.1281 141.114 23.9894 141.114 25.0518C141.114 26.1142 141.976 26.9755 143.038 26.9755C144.101 26.9755 144.962 26.1142 144.962 25.0518Z"
              fill="#005574"
            />
            <path
              d="M62.8848 30.183C62.8848 29.1206 62.0235 28.2594 60.9611 28.2594C59.8987 28.2594 59.0375 29.1206 59.0375 30.183C59.0375 31.2454 59.8987 32.1067 60.9611 32.1067C62.0235 32.1067 62.8848 31.2454 62.8848 30.183Z"
              fill="#005574"
            />
            <path
              d="M68.0153 30.183C68.0153 29.1206 67.154 28.2594 66.0916 28.2594C65.0292 28.2594 64.168 29.1206 64.168 30.183C64.168 31.2454 65.0292 32.1067 66.0916 32.1067C67.154 32.1067 68.0153 31.2454 68.0153 30.183Z"
              fill="#005574"
            />
            <path
              d="M73.1442 30.183C73.1442 29.1206 72.2829 28.2594 71.2205 28.2594C70.1581 28.2594 69.2969 29.1206 69.2969 30.183C69.2969 31.2454 70.1581 32.1067 71.2205 32.1067C72.2829 32.1067 73.1442 31.2454 73.1442 30.183Z"
              fill="#005574"
            />
            <path
              d="M78.2747 30.183C78.2747 29.1206 77.4134 28.2594 76.351 28.2594C75.2886 28.2594 74.4274 29.1206 74.4274 30.183C74.4274 31.2454 75.2886 32.1067 76.351 32.1067C77.4134 32.1067 78.2747 31.2454 78.2747 30.183Z"
              fill="#005574"
            />
            <path
              d="M88.534 30.183C88.534 29.1206 87.6728 28.2594 86.6104 28.2594C85.548 28.2594 84.6867 29.1206 84.6867 30.183C84.6867 31.2454 85.548 32.1067 86.6104 32.1067C87.6728 32.1067 88.534 31.2454 88.534 30.183Z"
              fill="#005574"
            />
            <path
              d="M93.6637 30.183C93.6637 29.1206 92.8025 28.2594 91.7401 28.2594C90.6777 28.2594 89.8164 29.1206 89.8164 30.183C89.8164 31.2454 90.6777 32.1067 91.7401 32.1067C92.8025 32.1067 93.6637 31.2454 93.6637 30.183Z"
              fill="#005574"
            />
            <path
              d="M98.7942 30.183C98.7942 29.1206 97.933 28.2594 96.8706 28.2594C95.8082 28.2594 94.9469 29.1206 94.9469 30.183C94.9469 31.2454 95.8082 32.1067 96.8706 32.1067C97.933 32.1067 98.7942 31.2454 98.7942 30.183Z"
              fill="#005574"
            />
            <path
              d="M114.182 30.183C114.182 29.1206 113.321 28.2594 112.259 28.2594C111.196 28.2594 110.335 29.1206 110.335 30.183C110.335 31.2454 111.196 32.1067 112.259 32.1067C113.321 32.1067 114.182 31.2454 114.182 30.183Z"
              fill="#005574"
            />
            <path
              d="M124.443 30.183C124.443 29.1206 123.581 28.2594 122.519 28.2594C121.457 28.2594 120.595 29.1206 120.595 30.183C120.595 31.2454 121.457 32.1067 122.519 32.1067C123.581 32.1067 124.443 31.2454 124.443 30.183Z"
              fill="#005574"
            />
            <path
              d="M129.572 30.183C129.572 29.1206 128.71 28.2594 127.648 28.2594C126.586 28.2594 125.724 29.1206 125.724 30.183C125.724 31.2454 126.586 32.1067 127.648 32.1067C128.71 32.1067 129.572 31.2454 129.572 30.183Z"
              fill="#005574"
            />
            <path
              d="M134.702 30.183C134.702 29.1206 133.841 28.2594 132.778 28.2594C131.716 28.2594 130.855 29.1206 130.855 30.183C130.855 31.2454 131.716 32.1067 132.778 32.1067C133.841 32.1067 134.702 31.2454 134.702 30.183Z"
              fill="#005574"
            />
            <path
              d="M139.832 30.183C139.832 29.1206 138.97 28.2594 137.908 28.2594C136.846 28.2594 135.984 29.1206 135.984 30.183C135.984 31.2454 136.846 32.1067 137.908 32.1067C138.97 32.1067 139.832 31.2454 139.832 30.183Z"
              fill="#005574"
            />
            <path
              d="M144.962 30.183C144.962 29.1206 144.101 28.2594 143.038 28.2594C141.976 28.2594 141.114 29.1206 141.114 30.183C141.114 31.2454 141.976 32.1067 143.038 32.1067C144.101 32.1067 144.962 31.2454 144.962 30.183Z"
              fill="#005574"
            />
            <path
              d="M68.0153 35.3112C68.0153 34.2488 67.154 33.3875 66.0916 33.3875C65.0292 33.3875 64.168 34.2488 64.168 35.3112C64.168 36.3736 65.0292 37.2348 66.0916 37.2348C67.154 37.2348 68.0153 36.3736 68.0153 35.3112Z"
              fill="#005574"
            />
            <path
              d="M73.1442 35.3112C73.1442 34.2488 72.2829 33.3875 71.2205 33.3875C70.1581 33.3875 69.2969 34.2488 69.2969 35.3112C69.2969 36.3736 70.1581 37.2348 71.2205 37.2348C72.2829 37.2348 73.1442 36.3736 73.1442 35.3112Z"
              fill="#005574"
            />
            <path
              d="M93.6637 35.3112C93.6637 34.2488 92.8025 33.3875 91.7401 33.3875C90.6777 33.3875 89.8164 34.2488 89.8164 35.3112C89.8164 36.3736 90.6777 37.2348 91.7401 37.2348C92.8025 37.2348 93.6637 36.3736 93.6637 35.3112Z"
              fill="#005574"
            />
            <path
              d="M109.054 35.3112C109.054 34.2488 108.192 33.3875 107.13 33.3875C106.067 33.3875 105.206 34.2488 105.206 35.3112C105.206 36.3736 106.067 37.2348 107.13 37.2348C108.192 37.2348 109.054 36.3736 109.054 35.3112Z"
              fill="#005574"
            />
            <path
              d="M114.182 35.3112C114.182 34.2488 113.321 33.3875 112.259 33.3875C111.196 33.3875 110.335 34.2488 110.335 35.3112C110.335 36.3736 111.196 37.2348 112.259 37.2348C113.321 37.2348 114.182 36.3736 114.182 35.3112Z"
              fill="#005574"
            />
            <path
              d="M119.312 35.3112C119.312 34.2488 118.451 33.3875 117.389 33.3875C116.326 33.3875 115.465 34.2488 115.465 35.3112C115.465 36.3736 116.326 37.2348 117.389 37.2348C118.451 37.2348 119.312 36.3736 119.312 35.3112Z"
              fill="#005574"
            />
            <path
              d="M134.702 35.3112C134.702 34.2488 133.841 33.3875 132.778 33.3875C131.716 33.3875 130.855 34.2488 130.855 35.3112C130.855 36.3736 131.716 37.2348 132.778 37.2348C133.841 37.2348 134.702 36.3736 134.702 35.3112Z"
              fill="#005574"
            />
            <path
              d="M139.832 35.3112C139.832 34.2488 138.97 33.3875 137.908 33.3875C136.846 33.3875 135.984 34.2488 135.984 35.3112C135.984 36.3736 136.846 37.2348 137.908 37.2348C138.97 37.2348 139.832 36.3736 139.832 35.3112Z"
              fill="#005574"
            />
            <path
              d="M73.1442 40.4424C73.1442 39.38 72.2829 38.5187 71.2205 38.5187C70.1581 38.5187 69.2969 39.38 69.2969 40.4424C69.2969 41.5048 70.1581 42.3661 71.2205 42.3661C72.2829 42.3661 73.1442 41.5048 73.1442 40.4424Z"
              fill="#005574"
            />
            <path
              d="M78.2747 40.4424C78.2747 39.38 77.4134 38.5187 76.351 38.5187C75.2886 38.5187 74.4274 39.38 74.4274 40.4424C74.4274 41.5048 75.2886 42.3661 76.351 42.3661C77.4134 42.3661 78.2747 41.5048 78.2747 40.4424Z"
              fill="#005574"
            />
            <path
              d="M83.4043 40.4424C83.4043 39.38 82.5431 38.5187 81.4807 38.5187C80.4183 38.5187 79.557 39.38 79.557 40.4424C79.557 41.5048 80.4183 42.3661 81.4807 42.3661C82.5431 42.3661 83.4043 41.5048 83.4043 40.4424Z"
              fill="#005574"
            />
            <path
              d="M88.534 40.4424C88.534 39.38 87.6728 38.5187 86.6104 38.5187C85.548 38.5187 84.6867 39.38 84.6867 40.4424C84.6867 41.5048 85.548 42.3661 86.6104 42.3661C87.6728 42.3661 88.534 41.5048 88.534 40.4424Z"
              fill="#005574"
            />
            <path
              d="M93.6637 40.4424C93.6637 39.38 92.8025 38.5187 91.7401 38.5187C90.6777 38.5187 89.8164 39.38 89.8164 40.4424C89.8164 41.5048 90.6777 42.3661 91.7401 42.3661C92.8025 42.3661 93.6637 41.5048 93.6637 40.4424Z"
              fill="#005574"
            />
            <path
              d="M98.7942 40.4424C98.7942 39.38 97.933 38.5187 96.8706 38.5187C95.8082 38.5187 94.9469 39.38 94.9469 40.4424C94.9469 41.5048 95.8082 42.3661 96.8706 42.3661C97.933 42.3661 98.7942 41.5048 98.7942 40.4424Z"
              fill="#005574"
            />
            <path
              d="M119.312 40.4424C119.312 39.38 118.451 38.5187 117.389 38.5187C116.326 38.5187 115.465 39.38 115.465 40.4424C115.465 41.5048 116.326 42.3661 117.389 42.3661C118.451 42.3661 119.312 41.5048 119.312 40.4424Z"
              fill="#005574"
            />
            <path
              d="M129.572 40.4424C129.572 39.38 128.71 38.5187 127.648 38.5187C126.586 38.5187 125.724 39.38 125.724 40.4424C125.724 41.5048 126.586 42.3661 127.648 42.3661C128.71 42.3661 129.572 41.5048 129.572 40.4424Z"
              fill="#005574"
            />
            <path
              d="M144.962 40.4424C144.962 39.38 144.101 38.5187 143.038 38.5187C141.976 38.5187 141.114 39.38 141.114 40.4424C141.114 41.5048 141.976 42.3661 143.038 42.3661C144.101 42.3661 144.962 41.5048 144.962 40.4424Z"
              fill="#005574"
            />
            <path
              d="M62.8848 45.5737C62.8848 44.5113 62.0235 43.65 60.9611 43.65C59.8987 43.65 59.0375 44.5113 59.0375 45.5737C59.0375 46.6361 59.8987 47.4973 60.9611 47.4973C62.0235 47.4973 62.8848 46.6361 62.8848 45.5737Z"
              fill="#005574"
            />
            <path
              d="M73.1442 45.5737C73.1442 44.5113 72.2829 43.65 71.2205 43.65C70.1581 43.65 69.2969 44.5113 69.2969 45.5737C69.2969 46.6361 70.1581 47.4973 71.2205 47.4973C72.2829 47.4973 73.1442 46.6361 73.1442 45.5737Z"
              fill="#005574"
            />
            <path
              d="M93.6637 45.5737C93.6637 44.5113 92.8025 43.65 91.7401 43.65C90.6777 43.65 89.8164 44.5113 89.8164 45.5737C89.8164 46.6361 90.6777 47.4973 91.7401 47.4973C92.8025 47.4973 93.6637 46.6361 93.6637 45.5737Z"
              fill="#005574"
            />
            <path
              d="M114.182 45.5737C114.182 44.5113 113.321 43.65 112.259 43.65C111.196 43.65 110.335 44.5113 110.335 45.5737C110.335 46.6361 111.196 47.4973 112.259 47.4973C113.321 47.4973 114.182 46.6361 114.182 45.5737Z"
              fill="#005574"
            />
            <path
              d="M119.312 45.5737C119.312 44.5113 118.451 43.65 117.389 43.65C116.326 43.65 115.465 44.5113 115.465 45.5737C115.465 46.6361 116.326 47.4973 117.389 47.4973C118.451 47.4973 119.312 46.6361 119.312 45.5737Z"
              fill="#005574"
            />
            <path
              d="M124.443 45.5737C124.443 44.5113 123.581 43.65 122.519 43.65C121.457 43.65 120.595 44.5113 120.595 45.5737C120.595 46.6361 121.457 47.4973 122.519 47.4973C123.581 47.4973 124.443 46.6361 124.443 45.5737Z"
              fill="#005574"
            />
            <path
              d="M62.8848 50.6987C62.8848 49.6363 62.0235 48.775 60.9611 48.775C59.8987 48.775 59.0375 49.6363 59.0375 50.6987C59.0375 51.7611 59.8987 52.6223 60.9611 52.6223C62.0235 52.6223 62.8848 51.7611 62.8848 50.6987Z"
              fill="#005574"
            />
            <path
              d="M73.1442 50.6987C73.1442 49.6363 72.2829 48.775 71.2205 48.775C70.1581 48.775 69.2969 49.6363 69.2969 50.6987C69.2969 51.7611 70.1581 52.6223 71.2205 52.6223C72.2829 52.6223 73.1442 51.7611 73.1442 50.6987Z"
              fill="#005574"
            />
            <path
              d="M83.4043 50.6987C83.4043 49.6363 82.5431 48.775 81.4807 48.775C80.4183 48.775 79.557 49.6363 79.557 50.6987C79.557 51.7611 80.4183 52.6223 81.4807 52.6223C82.5431 52.6223 83.4043 51.7611 83.4043 50.6987Z"
              fill="#005574"
            />
            <path
              d="M93.6637 50.6987C93.6637 49.6363 92.8025 48.775 91.7401 48.775C90.6777 48.775 89.8164 49.6363 89.8164 50.6987C89.8164 51.7611 90.6777 52.6223 91.7401 52.6223C92.8025 52.6223 93.6637 51.7611 93.6637 50.6987Z"
              fill="#005574"
            />
            <path
              d="M103.923 50.6987C103.923 49.6363 103.062 48.775 101.999 48.775C100.937 48.775 100.076 49.6363 100.076 50.6987C100.076 51.7611 100.937 52.6223 101.999 52.6223C103.062 52.6223 103.923 51.7611 103.923 50.6987Z"
              fill="#005574"
            />
            <path
              d="M114.182 50.6987C114.182 49.6363 113.321 48.775 112.259 48.775C111.196 48.775 110.335 49.6363 110.335 50.6987C110.335 51.7611 111.196 52.6223 112.259 52.6223C113.321 52.6223 114.182 51.7611 114.182 50.6987Z"
              fill="#005574"
            />
            <path
              d="M124.443 50.6987C124.443 49.6363 123.581 48.775 122.519 48.775C121.457 48.775 120.595 49.6363 120.595 50.6987C120.595 51.7611 121.457 52.6223 122.519 52.6223C123.581 52.6223 124.443 51.7611 124.443 50.6987Z"
              fill="#005574"
            />
            <path
              d="M134.702 50.6987C134.702 49.6363 133.841 48.775 132.778 48.775C131.716 48.775 130.855 49.6363 130.855 50.6987C130.855 51.7611 131.716 52.6223 132.778 52.6223C133.841 52.6223 134.702 51.7611 134.702 50.6987Z"
              fill="#005574"
            />
            <path
              d="M144.962 50.6987C144.962 49.6363 144.101 48.775 143.038 48.775C141.976 48.775 141.114 49.6363 141.114 50.6987C141.114 51.7611 141.976 52.6223 143.038 52.6223C144.101 52.6223 144.962 51.7611 144.962 50.6987Z"
              fill="#005574"
            />
            <path
              d="M62.8848 55.8299C62.8848 54.7675 62.0235 53.9062 60.9611 53.9062C59.8987 53.9062 59.0375 54.7675 59.0375 55.8299C59.0375 56.8923 59.8987 57.7536 60.9611 57.7536C62.0235 57.7536 62.8848 56.8923 62.8848 55.8299Z"
              fill="#005574"
            />
            <path
              d="M68.0153 55.8299C68.0153 54.7675 67.154 53.9062 66.0916 53.9062C65.0292 53.9062 64.168 54.7675 64.168 55.8299C64.168 56.8923 65.0292 57.7536 66.0916 57.7536C67.154 57.7536 68.0153 56.8923 68.0153 55.8299Z"
              fill="#005574"
            />
            <path
              d="M73.1442 55.8299C73.1442 54.7675 72.2829 53.9062 71.2205 53.9062C70.1581 53.9062 69.2969 54.7675 69.2969 55.8299C69.2969 56.8923 70.1581 57.7536 71.2205 57.7536C72.2829 57.7536 73.1442 56.8923 73.1442 55.8299Z"
              fill="#005574"
            />
            <path
              d="M88.534 55.8299C88.534 54.7675 87.6728 53.9062 86.6104 53.9062C85.548 53.9062 84.6867 54.7675 84.6867 55.8299C84.6867 56.8923 85.548 57.7536 86.6104 57.7536C87.6728 57.7536 88.534 56.8923 88.534 55.8299Z"
              fill="#005574"
            />
            <path
              d="M103.923 55.8299C103.923 54.7675 103.062 53.9062 101.999 53.9062C100.937 53.9062 100.076 54.7675 100.076 55.8299C100.076 56.8923 100.937 57.7536 101.999 57.7536C103.062 57.7536 103.923 56.8923 103.923 55.8299Z"
              fill="#005574"
            />
            <path
              d="M109.054 55.8299C109.054 54.7675 108.192 53.9062 107.13 53.9062C106.067 53.9062 105.206 54.7675 105.206 55.8299C105.206 56.8923 106.067 57.7536 107.13 57.7536C108.192 57.7536 109.054 56.8923 109.054 55.8299Z"
              fill="#005574"
            />
            <path
              d="M124.443 55.8299C124.443 54.7675 123.581 53.9062 122.519 53.9062C121.457 53.9062 120.595 54.7675 120.595 55.8299C120.595 56.8923 121.457 57.7536 122.519 57.7536C123.581 57.7536 124.443 56.8923 124.443 55.8299Z"
              fill="#005574"
            />
            <path
              d="M129.572 55.8299C129.572 54.7675 128.71 53.9062 127.648 53.9062C126.586 53.9062 125.724 54.7675 125.724 55.8299C125.724 56.8923 126.586 57.7536 127.648 57.7536C128.71 57.7536 129.572 56.8923 129.572 55.8299Z"
              fill="#005574"
            />
            <path
              d="M144.962 55.8299C144.962 54.7675 144.101 53.9062 143.038 53.9062C141.976 53.9062 141.114 54.7675 141.114 55.8299C141.114 56.8923 141.976 57.7536 143.038 57.7536C144.101 57.7536 144.962 56.8923 144.962 55.8299Z"
              fill="#005574"
            />
            <path
              d="M32.1067 60.9612C32.1067 59.8988 31.2455 59.0375 30.1831 59.0375C29.1207 59.0375 28.2594 59.8988 28.2594 60.9612C28.2594 62.0236 29.1207 62.8848 30.1831 62.8848C31.2455 62.8848 32.1067 62.0236 32.1067 60.9612Z"
              fill="#005574"
            />
            <path
              d="M37.2364 60.9612C37.2364 59.8988 36.3751 59.0375 35.3127 59.0375C34.2503 59.0375 33.389 59.8988 33.389 60.9612C33.389 62.0236 34.2503 62.8848 35.3127 62.8848C36.3751 62.8848 37.2364 62.0236 37.2364 60.9612Z"
              fill="#005574"
            />
            <path
              d="M42.3661 60.9612C42.3661 59.8988 41.5048 59.0375 40.4424 59.0375C39.38 59.0375 38.5187 59.8988 38.5187 60.9612C38.5187 62.0236 39.38 62.8848 40.4424 62.8848C41.5048 62.8848 42.3661 62.0236 42.3661 60.9612Z"
              fill="#005574"
            />
            <path
              d="M52.6255 60.9612C52.6255 59.8988 51.7642 59.0375 50.7018 59.0375C49.6394 59.0375 48.7781 59.8988 48.7781 60.9612C48.7781 62.0236 49.6394 62.8848 50.7018 62.8848C51.7642 62.8848 52.6255 62.0236 52.6255 60.9612Z"
              fill="#005574"
            />
            <path
              d="M62.8848 60.9612C62.8848 59.8988 62.0235 59.0375 60.9611 59.0375C59.8987 59.0375 59.0375 59.8988 59.0375 60.9612C59.0375 62.0236 59.8987 62.8848 60.9611 62.8848C62.0235 62.8848 62.8848 62.0236 62.8848 60.9612Z"
              fill="#005574"
            />
            <path
              d="M68.0153 60.9612C68.0153 59.8988 67.154 59.0375 66.0916 59.0375C65.0292 59.0375 64.168 59.8988 64.168 60.9612C64.168 62.0236 65.0292 62.8848 66.0916 62.8848C67.154 62.8848 68.0153 62.0236 68.0153 60.9612Z"
              fill="#005574"
            />
            <path
              d="M78.2747 60.9612C78.2747 59.8988 77.4134 59.0375 76.351 59.0375C75.2886 59.0375 74.4274 59.8988 74.4274 60.9612C74.4274 62.0236 75.2886 62.8848 76.351 62.8848C77.4134 62.8848 78.2747 62.0236 78.2747 60.9612Z"
              fill="#005574"
            />
            <path
              d="M88.534 60.9612C88.534 59.8988 87.6728 59.0375 86.6104 59.0375C85.548 59.0375 84.6867 59.8988 84.6867 60.9612C84.6867 62.0236 85.548 62.8848 86.6104 62.8848C87.6728 62.8848 88.534 62.0236 88.534 60.9612Z"
              fill="#005574"
            />
            <path
              d="M93.6637 60.9612C93.6637 59.8988 92.8025 59.0375 91.7401 59.0375C90.6777 59.0375 89.8164 59.8988 89.8164 60.9612C89.8164 62.0236 90.6777 62.8848 91.7401 62.8848C92.8025 62.8848 93.6637 62.0236 93.6637 60.9612Z"
              fill="#005574"
            />
            <path
              d="M109.054 60.9612C109.054 59.8988 108.192 59.0375 107.13 59.0375C106.067 59.0375 105.206 59.8988 105.206 60.9612C105.206 62.0236 106.067 62.8848 107.13 62.8848C108.192 62.8848 109.054 62.0236 109.054 60.9612Z"
              fill="#005574"
            />
            <path
              d="M114.182 60.9612C114.182 59.8988 113.321 59.0375 112.259 59.0375C111.196 59.0375 110.335 59.8988 110.335 60.9612C110.335 62.0236 111.196 62.8848 112.259 62.8848C113.321 62.8848 114.182 62.0236 114.182 60.9612Z"
              fill="#005574"
            />
            <path
              d="M144.962 60.9612C144.962 59.8988 144.101 59.0375 143.038 59.0375C141.976 59.0375 141.114 59.8988 141.114 60.9612C141.114 62.0236 141.976 62.8848 143.038 62.8848C144.101 62.8848 144.962 62.0236 144.962 60.9612Z"
              fill="#005574"
            />
            <path
              d="M150.091 60.9612C150.091 59.8988 149.23 59.0375 148.168 59.0375C147.105 59.0375 146.244 59.8988 146.244 60.9612C146.244 62.0236 147.105 62.8848 148.168 62.8848C149.23 62.8848 150.091 62.0236 150.091 60.9612Z"
              fill="#005574"
            />
            <path
              d="M155.221 60.9612C155.221 59.8988 154.359 59.0375 153.297 59.0375C152.235 59.0375 151.373 59.8988 151.373 60.9612C151.373 62.0236 152.235 62.8848 153.297 62.8848C154.359 62.8848 155.221 62.0236 155.221 60.9612Z"
              fill="#005574"
            />
            <path
              d="M160.35 60.9612C160.35 59.8988 159.489 59.0375 158.427 59.0375C157.364 59.0375 156.503 59.8988 156.503 60.9612C156.503 62.0236 157.364 62.8848 158.427 62.8848C159.489 62.8848 160.35 62.0236 160.35 60.9612Z"
              fill="#005574"
            />
            <path
              d="M175.74 60.9612C175.74 59.8988 174.879 59.0375 173.816 59.0375C172.754 59.0375 171.893 59.8988 171.893 60.9612C171.893 62.0236 172.754 62.8848 173.816 62.8848C174.879 62.8848 175.74 62.0236 175.74 60.9612Z"
              fill="#005574"
            />
            <path
              d="M180.87 60.9612C180.87 59.8988 180.008 59.0375 178.946 59.0375C177.884 59.0375 177.022 59.8988 177.022 60.9612C177.022 62.0236 177.884 62.8848 178.946 62.8848C180.008 62.8848 180.87 62.0236 180.87 60.9612Z"
              fill="#005574"
            />
            <path
              d="M186 60.9612C186 59.8988 185.138 59.0375 184.076 59.0375C183.014 59.0375 182.152 59.8988 182.152 60.9612C182.152 62.0236 183.014 62.8848 184.076 62.8848C185.138 62.8848 186 62.0236 186 60.9612Z"
              fill="#005574"
            />
            <path
              d="M32.1067 66.0893C32.1067 65.0269 31.2455 64.1656 30.1831 64.1656C29.1207 64.1656 28.2594 65.0269 28.2594 66.0893C28.2594 67.1517 29.1207 68.013 30.1831 68.013C31.2455 68.013 32.1067 67.1517 32.1067 66.0893Z"
              fill="#005574"
            />
            <path
              d="M47.4958 66.0893C47.4958 65.0269 46.6345 64.1656 45.5721 64.1656C44.5097 64.1656 43.6484 65.0269 43.6484 66.0893C43.6484 67.1517 44.5097 68.013 45.5721 68.013C46.6345 68.013 47.4958 67.1517 47.4958 66.0893Z"
              fill="#005574"
            />
            <path
              d="M68.0153 66.0893C68.0153 65.0269 67.154 64.1656 66.0916 64.1656C65.0292 64.1656 64.168 65.0269 64.168 66.0893C64.168 67.1517 65.0292 68.013 66.0916 68.013C67.154 68.013 68.0153 67.1517 68.0153 66.0893Z"
              fill="#005574"
            />
            <path
              d="M73.1442 66.0893C73.1442 65.0269 72.2829 64.1656 71.2205 64.1656C70.1581 64.1656 69.2969 65.0269 69.2969 66.0893C69.2969 67.1517 70.1581 68.013 71.2205 68.013C72.2829 68.013 73.1442 67.1517 73.1442 66.0893Z"
              fill="#005574"
            />
            <path
              d="M78.2747 66.0893C78.2747 65.0269 77.4134 64.1656 76.351 64.1656C75.2886 64.1656 74.4274 65.0269 74.4274 66.0893C74.4274 67.1517 75.2886 68.013 76.351 68.013C77.4134 68.013 78.2747 67.1517 78.2747 66.0893Z"
              fill="#005574"
            />
            <path
              d="M83.4043 66.0893C83.4043 65.0269 82.5431 64.1656 81.4807 64.1656C80.4183 64.1656 79.557 65.0269 79.557 66.0893C79.557 67.1517 80.4183 68.013 81.4807 68.013C82.5431 68.013 83.4043 67.1517 83.4043 66.0893Z"
              fill="#005574"
            />
            <path
              d="M88.534 66.0893C88.534 65.0269 87.6728 64.1656 86.6104 64.1656C85.548 64.1656 84.6867 65.0269 84.6867 66.0893C84.6867 67.1517 85.548 68.013 86.6104 68.013C87.6728 68.013 88.534 67.1517 88.534 66.0893Z"
              fill="#005574"
            />
            <path
              d="M93.6637 66.0893C93.6637 65.0269 92.8025 64.1656 91.7401 64.1656C90.6777 64.1656 89.8164 65.0269 89.8164 66.0893C89.8164 67.1517 90.6777 68.013 91.7401 68.013C92.8025 68.013 93.6637 67.1517 93.6637 66.0893Z"
              fill="#005574"
            />
            <path
              d="M103.923 66.0893C103.923 65.0269 103.062 64.1656 101.999 64.1656C100.937 64.1656 100.076 65.0269 100.076 66.0893C100.076 67.1517 100.937 68.013 101.999 68.013C103.062 68.013 103.923 67.1517 103.923 66.0893Z"
              fill="#005574"
            />
            <path
              d="M114.182 66.0893C114.182 65.0269 113.321 64.1656 112.259 64.1656C111.196 64.1656 110.335 65.0269 110.335 66.0893C110.335 67.1517 111.196 68.013 112.259 68.013C113.321 68.013 114.182 67.1517 114.182 66.0893Z"
              fill="#005574"
            />
            <path
              d="M119.312 66.0893C119.312 65.0269 118.451 64.1656 117.389 64.1656C116.326 64.1656 115.465 65.0269 115.465 66.0893C115.465 67.1517 116.326 68.013 117.389 68.013C118.451 68.013 119.312 67.1517 119.312 66.0893Z"
              fill="#005574"
            />
            <path
              d="M134.702 66.0893C134.702 65.0269 133.841 64.1656 132.778 64.1656C131.716 64.1656 130.855 65.0269 130.855 66.0893C130.855 67.1517 131.716 68.013 132.778 68.013C133.841 68.013 134.702 67.1517 134.702 66.0893Z"
              fill="#005574"
            />
            <path
              d="M139.832 66.0893C139.832 65.0269 138.97 64.1656 137.908 64.1656C136.846 64.1656 135.984 65.0269 135.984 66.0893C135.984 67.1517 136.846 68.013 137.908 68.013C138.97 68.013 139.832 67.1517 139.832 66.0893Z"
              fill="#005574"
            />
            <path
              d="M150.091 66.0893C150.091 65.0269 149.23 64.1656 148.168 64.1656C147.105 64.1656 146.244 65.0269 146.244 66.0893C146.244 67.1517 147.105 68.013 148.168 68.013C149.23 68.013 150.091 67.1517 150.091 66.0893Z"
              fill="#005574"
            />
            <path
              d="M155.221 66.0893C155.221 65.0269 154.359 64.1656 153.297 64.1656C152.235 64.1656 151.373 65.0269 151.373 66.0893C151.373 67.1517 152.235 68.013 153.297 68.013C154.359 68.013 155.221 67.1517 155.221 66.0893Z"
              fill="#005574"
            />
            <path
              d="M170.61 66.0893C170.61 65.0269 169.749 64.1656 168.687 64.1656C167.624 64.1656 166.763 65.0269 166.763 66.0893C166.763 67.1517 167.624 68.013 168.687 68.013C169.749 68.013 170.61 67.1517 170.61 66.0893Z"
              fill="#005574"
            />
            <path
              d="M175.74 66.0893C175.74 65.0269 174.879 64.1656 173.816 64.1656C172.754 64.1656 171.893 65.0269 171.893 66.0893C171.893 67.1517 172.754 68.013 173.816 68.013C174.879 68.013 175.74 67.1517 175.74 66.0893Z"
              fill="#005574"
            />
            <path
              d="M186 66.0893C186 65.0269 185.138 64.1656 184.076 64.1656C183.014 64.1656 182.152 65.0269 182.152 66.0893C182.152 67.1517 183.014 68.013 184.076 68.013C185.138 68.013 186 67.1517 186 66.0893Z"
              fill="#005574"
            />
            <path
              d="M42.3661 71.2205C42.3661 70.1581 41.5048 69.2969 40.4424 69.2969C39.38 69.2969 38.5187 70.1581 38.5187 71.2205C38.5187 72.2829 39.38 73.1442 40.4424 73.1442C41.5048 73.1442 42.3661 72.2829 42.3661 71.2205Z"
              fill="#005574"
            />
            <path
              d="M52.6255 71.2205C52.6255 70.1581 51.7642 69.2969 50.7018 69.2969C49.6394 69.2969 48.7781 70.1581 48.7781 71.2205C48.7781 72.2829 49.6394 73.1442 50.7018 73.1442C51.7642 73.1442 52.6255 72.2829 52.6255 71.2205Z"
              fill="#005574"
            />
            <path
              d="M57.7552 71.2205C57.7552 70.1581 56.8939 69.2969 55.8315 69.2969C54.7691 69.2969 53.9078 70.1581 53.9078 71.2205C53.9078 72.2829 54.7691 73.1442 55.8315 73.1442C56.8939 73.1442 57.7552 72.2829 57.7552 71.2205Z"
              fill="#005574"
            />
            <path
              d="M68.0153 71.2205C68.0153 70.1581 67.154 69.2969 66.0916 69.2969C65.0292 69.2969 64.168 70.1581 64.168 71.2205C64.168 72.2829 65.0292 73.1442 66.0916 73.1442C67.154 73.1442 68.0153 72.2829 68.0153 71.2205Z"
              fill="#005574"
            />
            <path
              d="M83.4043 71.2205C83.4043 70.1581 82.5431 69.2969 81.4807 69.2969C80.4183 69.2969 79.557 70.1581 79.557 71.2205C79.557 72.2829 80.4183 73.1442 81.4807 73.1442C82.5431 73.1442 83.4043 72.2829 83.4043 71.2205Z"
              fill="#005574"
            />
            <path
              d="M88.534 71.2205C88.534 70.1581 87.6728 69.2969 86.6104 69.2969C85.548 69.2969 84.6867 70.1581 84.6867 71.2205C84.6867 72.2829 85.548 73.1442 86.6104 73.1442C87.6728 73.1442 88.534 72.2829 88.534 71.2205Z"
              fill="#005574"
            />
            <path
              d="M103.923 71.2205C103.923 70.1581 103.062 69.2969 101.999 69.2969C100.937 69.2969 100.076 70.1581 100.076 71.2205C100.076 72.2829 100.937 73.1442 101.999 73.1442C103.062 73.1442 103.923 72.2829 103.923 71.2205Z"
              fill="#005574"
            />
            <path
              d="M109.054 71.2205C109.054 70.1581 108.192 69.2969 107.13 69.2969C106.067 69.2969 105.206 70.1581 105.206 71.2205C105.206 72.2829 106.067 73.1442 107.13 73.1442C108.192 73.1442 109.054 72.2829 109.054 71.2205Z"
              fill="#005574"
            />
            <path
              d="M114.182 71.2205C114.182 70.1581 113.321 69.2969 112.259 69.2969C111.196 69.2969 110.335 70.1581 110.335 71.2205C110.335 72.2829 111.196 73.1442 112.259 73.1442C113.321 73.1442 114.182 72.2829 114.182 71.2205Z"
              fill="#005574"
            />
            <path
              d="M119.312 71.2205C119.312 70.1581 118.451 69.2969 117.389 69.2969C116.326 69.2969 115.465 70.1581 115.465 71.2205C115.465 72.2829 116.326 73.1442 117.389 73.1442C118.451 73.1442 119.312 72.2829 119.312 71.2205Z"
              fill="#005574"
            />
            <path
              d="M134.702 71.2205C134.702 70.1581 133.841 69.2969 132.778 69.2969C131.716 69.2969 130.855 70.1581 130.855 71.2205C130.855 72.2829 131.716 73.1442 132.778 73.1442C133.841 73.1442 134.702 72.2829 134.702 71.2205Z"
              fill="#005574"
            />
            <path
              d="M144.962 71.2205C144.962 70.1581 144.101 69.2969 143.038 69.2969C141.976 69.2969 141.114 70.1581 141.114 71.2205C141.114 72.2829 141.976 73.1442 143.038 73.1442C144.101 73.1442 144.962 72.2829 144.962 71.2205Z"
              fill="#005574"
            />
            <path
              d="M150.091 71.2205C150.091 70.1581 149.23 69.2969 148.168 69.2969C147.105 69.2969 146.244 70.1581 146.244 71.2205C146.244 72.2829 147.105 73.1442 148.168 73.1442C149.23 73.1442 150.091 72.2829 150.091 71.2205Z"
              fill="#005574"
            />
            <path
              d="M160.35 71.2205C160.35 70.1581 159.489 69.2969 158.427 69.2969C157.364 69.2969 156.503 70.1581 156.503 71.2205C156.503 72.2829 157.364 73.1442 158.427 73.1442C159.489 73.1442 160.35 72.2829 160.35 71.2205Z"
              fill="#005574"
            />
            <path
              d="M175.74 71.2205C175.74 70.1581 174.879 69.2969 173.816 69.2969C172.754 69.2969 171.893 70.1581 171.893 71.2205C171.893 72.2829 172.754 73.1442 173.816 73.1442C174.879 73.1442 175.74 72.2829 175.74 71.2205Z"
              fill="#005574"
            />
            <path
              d="M180.87 71.2205C180.87 70.1581 180.008 69.2969 178.946 69.2969C177.884 69.2969 177.022 70.1581 177.022 71.2205C177.022 72.2829 177.884 73.1442 178.946 73.1442C180.008 73.1442 180.87 72.2829 180.87 71.2205Z"
              fill="#005574"
            />
            <path
              d="M42.3661 76.3487C42.3661 75.2863 41.5048 74.425 40.4424 74.425C39.38 74.425 38.5187 75.2863 38.5187 76.3487C38.5187 77.4111 39.38 78.2723 40.4424 78.2723C41.5048 78.2723 42.3661 77.4111 42.3661 76.3487Z"
              fill="#005574"
            />
            <path
              d="M47.4958 76.3487C47.4958 75.2863 46.6345 74.425 45.5721 74.425C44.5097 74.425 43.6484 75.2863 43.6484 76.3487C43.6484 77.4111 44.5097 78.2723 45.5721 78.2723C46.6345 78.2723 47.4958 77.4111 47.4958 76.3487Z"
              fill="#005574"
            />
            <path
              d="M57.7552 76.3487C57.7552 75.2863 56.8939 74.425 55.8315 74.425C54.7691 74.425 53.9078 75.2863 53.9078 76.3487C53.9078 77.4111 54.7691 78.2723 55.8315 78.2723C56.8939 78.2723 57.7552 77.4111 57.7552 76.3487Z"
              fill="#005574"
            />
            <path
              d="M144.962 76.3487C144.962 75.2863 144.101 74.425 143.038 74.425C141.976 74.425 141.114 75.2863 141.114 76.3487C141.114 77.4111 141.976 78.2723 143.038 78.2723C144.101 78.2723 144.962 77.4111 144.962 76.3487Z"
              fill="#005574"
            />
            <path
              d="M150.091 76.3487C150.091 75.2863 149.23 74.425 148.168 74.425C147.105 74.425 146.244 75.2863 146.244 76.3487C146.244 77.4111 147.105 78.2723 148.168 78.2723C149.23 78.2723 150.091 77.4111 150.091 76.3487Z"
              fill="#005574"
            />
            <path
              d="M170.61 76.3487C170.61 75.2863 169.749 74.425 168.687 74.425C167.624 74.425 166.763 75.2863 166.763 76.3487C166.763 77.4111 167.624 78.2723 168.687 78.2723C169.749 78.2723 170.61 77.4111 170.61 76.3487Z"
              fill="#005574"
            />
            <path
              d="M175.74 76.3487C175.74 75.2863 174.879 74.425 173.816 74.425C172.754 74.425 171.893 75.2863 171.893 76.3487C171.893 77.4111 172.754 78.2723 173.816 78.2723C174.879 78.2723 175.74 77.4111 175.74 76.3487Z"
              fill="#005574"
            />
            <path
              d="M37.2364 81.4799C37.2364 80.4175 36.3751 79.5563 35.3127 79.5563C34.2503 79.5563 33.389 80.4175 33.389 81.4799C33.389 82.5423 34.2503 83.4036 35.3127 83.4036C36.3751 83.4036 37.2364 82.5423 37.2364 81.4799Z"
              fill="#005574"
            />
            <path
              d="M47.4958 81.4799C47.4958 80.4175 46.6345 79.5563 45.5721 79.5563C44.5097 79.5563 43.6484 80.4175 43.6484 81.4799C43.6484 82.5423 44.5097 83.4036 45.5721 83.4036C46.6345 83.4036 47.4958 82.5423 47.4958 81.4799Z"
              fill="#005574"
            />
            <path
              d="M52.6255 81.4799C52.6255 80.4175 51.7642 79.5563 50.7018 79.5563C49.6394 79.5563 48.7781 80.4175 48.7781 81.4799C48.7781 82.5423 49.6394 83.4036 50.7018 83.4036C51.7642 83.4036 52.6255 82.5423 52.6255 81.4799Z"
              fill="#005574"
            />
            <path
              d="M62.8848 81.4799C62.8848 80.4175 62.0235 79.5563 60.9611 79.5563C59.8987 79.5563 59.0375 80.4175 59.0375 81.4799C59.0375 82.5423 59.8987 83.4036 60.9611 83.4036C62.0235 83.4036 62.8848 82.5423 62.8848 81.4799Z"
              fill="#005574"
            />
            <path
              d="M134.702 81.4799C134.702 80.4175 133.841 79.5563 132.778 79.5563C131.716 79.5563 130.855 80.4175 130.855 81.4799C130.855 82.5423 131.716 83.4036 132.778 83.4036C133.841 83.4036 134.702 82.5423 134.702 81.4799Z"
              fill="#005574"
            />
            <path
              d="M144.962 81.4799C144.962 80.4175 144.101 79.5563 143.038 79.5563C141.976 79.5563 141.114 80.4175 141.114 81.4799C141.114 82.5423 141.976 83.4036 143.038 83.4036C144.101 83.4036 144.962 82.5423 144.962 81.4799Z"
              fill="#005574"
            />
            <path
              d="M150.091 81.4799C150.091 80.4175 149.23 79.5563 148.168 79.5563C147.105 79.5563 146.244 80.4175 146.244 81.4799C146.244 82.5423 147.105 83.4036 148.168 83.4036C149.23 83.4036 150.091 82.5423 150.091 81.4799Z"
              fill="#005574"
            />
            <path
              d="M160.35 81.4799C160.35 80.4175 159.489 79.5563 158.427 79.5563C157.364 79.5563 156.503 80.4175 156.503 81.4799C156.503 82.5423 157.364 83.4036 158.427 83.4036C159.489 83.4036 160.35 82.5423 160.35 81.4799Z"
              fill="#005574"
            />
            <path
              d="M170.61 81.4799C170.61 80.4175 169.749 79.5563 168.687 79.5563C167.624 79.5563 166.763 80.4175 166.763 81.4799C166.763 82.5423 167.624 83.4036 168.687 83.4036C169.749 83.4036 170.61 82.5423 170.61 81.4799Z"
              fill="#005574"
            />
            <path
              d="M186 81.4799C186 80.4175 185.138 79.5563 184.076 79.5563C183.014 79.5563 182.152 80.4175 182.152 81.4799C182.152 82.5423 183.014 83.4036 184.076 83.4036C185.138 83.4036 186 82.5423 186 81.4799Z"
              fill="#005574"
            />
            <path
              d="M57.7552 86.6112C57.7552 85.5488 56.8939 84.6875 55.8315 84.6875C54.7691 84.6875 53.9078 85.5488 53.9078 86.6112C53.9078 87.6736 54.7691 88.5348 55.8315 88.5348C56.8939 88.5348 57.7552 87.6736 57.7552 86.6112Z"
              fill="#005574"
            />
            <path
              d="M62.8848 86.6112C62.8848 85.5488 62.0235 84.6875 60.9611 84.6875C59.8987 84.6875 59.0375 85.5488 59.0375 86.6112C59.0375 87.6736 59.8987 88.5348 60.9611 88.5348C62.0235 88.5348 62.8848 87.6736 62.8848 86.6112Z"
              fill="#005574"
            />
            <path
              d="M73.1442 86.6112C73.1442 85.5488 72.2829 84.6875 71.2205 84.6875C70.1581 84.6875 69.2969 85.5488 69.2969 86.6112C69.2969 87.6736 70.1581 88.5348 71.2205 88.5348C72.2829 88.5348 73.1442 87.6736 73.1442 86.6112Z"
              fill="#005574"
            />
            <path
              d="M139.832 86.6112C139.832 85.5488 138.97 84.6875 137.908 84.6875C136.846 84.6875 135.984 85.5488 135.984 86.6112C135.984 87.6736 136.846 88.5348 137.908 88.5348C138.97 88.5348 139.832 87.6736 139.832 86.6112Z"
              fill="#005574"
            />
            <path
              d="M150.091 86.6112C150.091 85.5488 149.23 84.6875 148.168 84.6875C147.105 84.6875 146.244 85.5488 146.244 86.6112C146.244 87.6736 147.105 88.5348 148.168 88.5348C149.23 88.5348 150.091 87.6736 150.091 86.6112Z"
              fill="#005574"
            />
            <path
              d="M155.221 86.6112C155.221 85.5488 154.359 84.6875 153.297 84.6875C152.235 84.6875 151.373 85.5488 151.373 86.6112C151.373 87.6736 152.235 88.5348 153.297 88.5348C154.359 88.5348 155.221 87.6736 155.221 86.6112Z"
              fill="#005574"
            />
            <path
              d="M165.481 86.6112C165.481 85.5488 164.619 84.6875 163.557 84.6875C162.494 84.6875 161.633 85.5488 161.633 86.6112C161.633 87.6736 162.494 88.5348 163.557 88.5348C164.619 88.5348 165.481 87.6736 165.481 86.6112Z"
              fill="#005574"
            />
            <path
              d="M170.61 86.6112C170.61 85.5488 169.749 84.6875 168.687 84.6875C167.624 84.6875 166.763 85.5488 166.763 86.6112C166.763 87.6736 167.624 88.5348 168.687 88.5348C169.749 88.5348 170.61 87.6736 170.61 86.6112Z"
              fill="#005574"
            />
            <path
              d="M175.74 86.6112C175.74 85.5488 174.879 84.6875 173.816 84.6875C172.754 84.6875 171.893 85.5488 171.893 86.6112C171.893 87.6736 172.754 88.5348 173.816 88.5348C174.879 88.5348 175.74 87.6736 175.74 86.6112Z"
              fill="#005574"
            />
            <path
              d="M186 86.6112C186 85.5488 185.138 84.6875 184.076 84.6875C183.014 84.6875 182.152 85.5488 182.152 86.6112C182.152 87.6736 183.014 88.5348 184.076 88.5348C185.138 88.5348 186 87.6736 186 86.6112Z"
              fill="#005574"
            />
            <path
              d="M21.8473 91.7393C21.8473 90.6769 20.9861 89.8156 19.9237 89.8156C18.8613 89.8156 18 90.6769 18 91.7393C18 92.8017 18.8613 93.663 19.9237 93.663C20.9861 93.663 21.8473 92.8017 21.8473 91.7393Z"
              fill="#005574"
            />
            <path
              d="M26.977 91.7393C26.977 90.6769 26.1158 89.8156 25.0534 89.8156C23.991 89.8156 23.1297 90.6769 23.1297 91.7393C23.1297 92.8017 23.991 93.663 25.0534 93.663C26.1158 93.663 26.977 92.8017 26.977 91.7393Z"
              fill="#005574"
            />
            <path
              d="M42.3661 91.7393C42.3661 90.6769 41.5048 89.8156 40.4424 89.8156C39.38 89.8156 38.5187 90.6769 38.5187 91.7393C38.5187 92.8017 39.38 93.663 40.4424 93.663C41.5048 93.663 42.3661 92.8017 42.3661 91.7393Z"
              fill="#005574"
            />
            <path
              d="M47.4958 91.7393C47.4958 90.6769 46.6345 89.8156 45.5721 89.8156C44.5097 89.8156 43.6484 90.6769 43.6484 91.7393C43.6484 92.8017 44.5097 93.663 45.5721 93.663C46.6345 93.663 47.4958 92.8017 47.4958 91.7393Z"
              fill="#005574"
            />
            <path
              d="M52.6255 91.7393C52.6255 90.6769 51.7642 89.8156 50.7018 89.8156C49.6394 89.8156 48.7781 90.6769 48.7781 91.7393C48.7781 92.8017 49.6394 93.663 50.7018 93.663C51.7642 93.663 52.6255 92.8017 52.6255 91.7393Z"
              fill="#005574"
            />
            <path
              d="M57.7552 91.7393C57.7552 90.6769 56.8939 89.8156 55.8315 89.8156C54.7691 89.8156 53.9078 90.6769 53.9078 91.7393C53.9078 92.8017 54.7691 93.663 55.8315 93.663C56.8939 93.663 57.7552 92.8017 57.7552 91.7393Z"
              fill="#005574"
            />
            <path
              d="M68.0153 91.7393C68.0153 90.6769 67.154 89.8156 66.0916 89.8156C65.0292 89.8156 64.168 90.6769 64.168 91.7393C64.168 92.8017 65.0292 93.663 66.0916 93.663C67.154 93.663 68.0153 92.8017 68.0153 91.7393Z"
              fill="#005574"
            />
            <path
              d="M73.1442 91.7393C73.1442 90.6769 72.2829 89.8156 71.2205 89.8156C70.1581 89.8156 69.2969 90.6769 69.2969 91.7393C69.2969 92.8017 70.1581 93.663 71.2205 93.663C72.2829 93.663 73.1442 92.8017 73.1442 91.7393Z"
              fill="#005574"
            />
            <path
              d="M134.702 91.7393C134.702 90.6769 133.841 89.8156 132.778 89.8156C131.716 89.8156 130.855 90.6769 130.855 91.7393C130.855 92.8017 131.716 93.663 132.778 93.663C133.841 93.663 134.702 92.8017 134.702 91.7393Z"
              fill="#005574"
            />
            <path
              d="M144.962 91.7393C144.962 90.6769 144.101 89.8156 143.038 89.8156C141.976 89.8156 141.114 90.6769 141.114 91.7393C141.114 92.8017 141.976 93.663 143.038 93.663C144.101 93.663 144.962 92.8017 144.962 91.7393Z"
              fill="#005574"
            />
            <path
              d="M150.091 91.7393C150.091 90.6769 149.23 89.8156 148.168 89.8156C147.105 89.8156 146.244 90.6769 146.244 91.7393C146.244 92.8017 147.105 93.663 148.168 93.663C149.23 93.663 150.091 92.8017 150.091 91.7393Z"
              fill="#005574"
            />
            <path
              d="M160.35 91.7393C160.35 90.6769 159.489 89.8156 158.427 89.8156C157.364 89.8156 156.503 90.6769 156.503 91.7393C156.503 92.8017 157.364 93.663 158.427 93.663C159.489 93.663 160.35 92.8017 160.35 91.7393Z"
              fill="#005574"
            />
            <path
              d="M165.481 91.7393C165.481 90.6769 164.619 89.8156 163.557 89.8156C162.494 89.8156 161.633 90.6769 161.633 91.7393C161.633 92.8017 162.494 93.663 163.557 93.663C164.619 93.663 165.481 92.8017 165.481 91.7393Z"
              fill="#005574"
            />
            <path
              d="M175.74 91.7393C175.74 90.6769 174.879 89.8156 173.816 89.8156C172.754 89.8156 171.893 90.6769 171.893 91.7393C171.893 92.8017 172.754 93.663 173.816 93.663C174.879 93.663 175.74 92.8017 175.74 91.7393Z"
              fill="#005574"
            />
            <path
              d="M180.87 91.7393C180.87 90.6769 180.008 89.8156 178.946 89.8156C177.884 89.8156 177.022 90.6769 177.022 91.7393C177.022 92.8017 177.884 93.663 178.946 93.663C180.008 93.663 180.87 92.8017 180.87 91.7393Z"
              fill="#005574"
            />
            <path
              d="M32.1067 96.8705C32.1067 95.8081 31.2455 94.9469 30.1831 94.9469C29.1207 94.9469 28.2594 95.8081 28.2594 96.8705C28.2594 97.9329 29.1207 98.7942 30.1831 98.7942C31.2455 98.7942 32.1067 97.9329 32.1067 96.8705Z"
              fill="#005574"
            />
            <path
              d="M42.3661 96.8705C42.3661 95.8081 41.5048 94.9469 40.4424 94.9469C39.38 94.9469 38.5187 95.8081 38.5187 96.8705C38.5187 97.9329 39.38 98.7942 40.4424 98.7942C41.5048 98.7942 42.3661 97.9329 42.3661 96.8705Z"
              fill="#005574"
            />
            <path
              d="M73.1442 96.8705C73.1442 95.8081 72.2829 94.9469 71.2205 94.9469C70.1581 94.9469 69.2969 95.8081 69.2969 96.8705C69.2969 97.9329 70.1581 98.7942 71.2205 98.7942C72.2829 98.7942 73.1442 97.9329 73.1442 96.8705Z"
              fill="#005574"
            />
            <path
              d="M134.702 96.8705C134.702 95.8081 133.841 94.9469 132.778 94.9469C131.716 94.9469 130.855 95.8081 130.855 96.8705C130.855 97.9329 131.716 98.7942 132.778 98.7942C133.841 98.7942 134.702 97.9329 134.702 96.8705Z"
              fill="#005574"
            />
            <path
              d="M139.832 96.8705C139.832 95.8081 138.97 94.9469 137.908 94.9469C136.846 94.9469 135.984 95.8081 135.984 96.8705C135.984 97.9329 136.846 98.7942 137.908 98.7942C138.97 98.7942 139.832 97.9329 139.832 96.8705Z"
              fill="#005574"
            />
            <path
              d="M150.091 96.8705C150.091 95.8081 149.23 94.9469 148.168 94.9469C147.105 94.9469 146.244 95.8081 146.244 96.8705C146.244 97.9329 147.105 98.7942 148.168 98.7942C149.23 98.7942 150.091 97.9329 150.091 96.8705Z"
              fill="#005574"
            />
            <path
              d="M165.481 96.8705C165.481 95.8081 164.619 94.9469 163.557 94.9469C162.494 94.9469 161.633 95.8081 161.633 96.8705C161.633 97.9329 162.494 98.7942 163.557 98.7942C164.619 98.7942 165.481 97.9329 165.481 96.8705Z"
              fill="#005574"
            />
            <path
              d="M170.61 96.8705C170.61 95.8081 169.749 94.9469 168.687 94.9469C167.624 94.9469 166.763 95.8081 166.763 96.8705C166.763 97.9329 167.624 98.7942 168.687 98.7942C169.749 98.7942 170.61 97.9329 170.61 96.8705Z"
              fill="#005574"
            />
            <path
              d="M175.74 96.8705C175.74 95.8081 174.879 94.9469 173.816 94.9469C172.754 94.9469 171.893 95.8081 171.893 96.8705C171.893 97.9329 172.754 98.7942 173.816 98.7942C174.879 98.7942 175.74 97.9329 175.74 96.8705Z"
              fill="#005574"
            />
            <path
              d="M21.8473 101.999C21.8473 100.936 20.9861 100.075 19.9237 100.075C18.8613 100.075 18 100.936 18 101.999C18 103.061 18.8613 103.922 19.9237 103.922C20.9861 103.922 21.8473 103.061 21.8473 101.999Z"
              fill="#005574"
            />
            <path
              d="M37.2364 101.999C37.2364 100.936 36.3751 100.075 35.3127 100.075C34.2503 100.075 33.389 100.936 33.389 101.999C33.389 103.061 34.2503 103.922 35.3127 103.922C36.3751 103.922 37.2364 103.061 37.2364 101.999Z"
              fill="#005574"
            />
            <path
              d="M47.4958 101.999C47.4958 100.936 46.6345 100.075 45.5721 100.075C44.5097 100.075 43.6484 100.936 43.6484 101.999C43.6484 103.061 44.5097 103.922 45.5721 103.922C46.6345 103.922 47.4958 103.061 47.4958 101.999Z"
              fill="#005574"
            />
            <path
              d="M52.6255 101.999C52.6255 100.936 51.7642 100.075 50.7018 100.075C49.6394 100.075 48.7781 100.936 48.7781 101.999C48.7781 103.061 49.6394 103.922 50.7018 103.922C51.7642 103.922 52.6255 103.061 52.6255 101.999Z"
              fill="#005574"
            />
            <path
              d="M68.0153 101.999C68.0153 100.936 67.154 100.075 66.0916 100.075C65.0292 100.075 64.168 100.936 64.168 101.999C64.168 103.061 65.0292 103.922 66.0916 103.922C67.154 103.922 68.0153 103.061 68.0153 101.999Z"
              fill="#005574"
            />
            <path
              d="M139.832 101.999C139.832 100.936 138.97 100.075 137.908 100.075C136.846 100.075 135.984 100.936 135.984 101.999C135.984 103.061 136.846 103.922 137.908 103.922C138.97 103.922 139.832 103.061 139.832 101.999Z"
              fill="#005574"
            />
            <path
              d="M165.481 101.999C165.481 100.936 164.619 100.075 163.557 100.075C162.494 100.075 161.633 100.936 161.633 101.999C161.633 103.061 162.494 103.922 163.557 103.922C164.619 103.922 165.481 103.061 165.481 101.999Z"
              fill="#005574"
            />
            <path
              d="M180.87 101.999C180.87 100.936 180.008 100.075 178.946 100.075C177.884 100.075 177.022 100.936 177.022 101.999C177.022 103.061 177.884 103.922 178.946 103.922C180.008 103.922 180.87 103.061 180.87 101.999Z"
              fill="#005574"
            />
            <path
              d="M186 101.999C186 100.936 185.138 100.075 184.076 100.075C183.014 100.075 182.152 100.936 182.152 101.999C182.152 103.061 183.014 103.922 184.076 103.922C185.138 103.922 186 103.061 186 101.999Z"
              fill="#005574"
            />
            <path
              d="M21.8473 107.127C21.8473 106.064 20.9861 105.203 19.9237 105.203C18.8613 105.203 18 106.064 18 107.127C18 108.189 18.8613 109.05 19.9237 109.05C20.9861 109.05 21.8473 108.189 21.8473 107.127Z"
              fill="#005574"
            />
            <path
              d="M32.1067 107.127C32.1067 106.064 31.2455 105.203 30.1831 105.203C29.1207 105.203 28.2594 106.064 28.2594 107.127C28.2594 108.189 29.1207 109.05 30.1831 109.05C31.2455 109.05 32.1067 108.189 32.1067 107.127Z"
              fill="#005574"
            />
            <path
              d="M37.2364 107.127C37.2364 106.064 36.3751 105.203 35.3127 105.203C34.2503 105.203 33.389 106.064 33.389 107.127C33.389 108.189 34.2503 109.05 35.3127 109.05C36.3751 109.05 37.2364 108.189 37.2364 107.127Z"
              fill="#005574"
            />
            <path
              d="M47.4958 107.127C47.4958 106.064 46.6345 105.203 45.5721 105.203C44.5097 105.203 43.6484 106.064 43.6484 107.127C43.6484 108.189 44.5097 109.05 45.5721 109.05C46.6345 109.05 47.4958 108.189 47.4958 107.127Z"
              fill="#005574"
            />
            <path
              d="M57.7552 107.127C57.7552 106.064 56.8939 105.203 55.8315 105.203C54.7691 105.203 53.9078 106.064 53.9078 107.127C53.9078 108.189 54.7691 109.05 55.8315 109.05C56.8939 109.05 57.7552 108.189 57.7552 107.127Z"
              fill="#005574"
            />
            <path
              d="M62.8848 107.127C62.8848 106.064 62.0235 105.203 60.9611 105.203C59.8987 105.203 59.0375 106.064 59.0375 107.127C59.0375 108.189 59.8987 109.05 60.9611 109.05C62.0235 109.05 62.8848 108.189 62.8848 107.127Z"
              fill="#005574"
            />
            <path
              d="M68.0153 107.127C68.0153 106.064 67.154 105.203 66.0916 105.203C65.0292 105.203 64.168 106.064 64.168 107.127C64.168 108.189 65.0292 109.05 66.0916 109.05C67.154 109.05 68.0153 108.189 68.0153 107.127Z"
              fill="#005574"
            />
            <path
              d="M139.832 107.127C139.832 106.064 138.97 105.203 137.908 105.203C136.846 105.203 135.984 106.064 135.984 107.127C135.984 108.189 136.846 109.05 137.908 109.05C138.97 109.05 139.832 108.189 139.832 107.127Z"
              fill="#005574"
            />
            <path
              d="M144.962 107.127C144.962 106.064 144.101 105.203 143.038 105.203C141.976 105.203 141.114 106.064 141.114 107.127C141.114 108.189 141.976 109.05 143.038 109.05C144.101 109.05 144.962 108.189 144.962 107.127Z"
              fill="#005574"
            />
            <path
              d="M150.091 107.127C150.091 106.064 149.23 105.203 148.168 105.203C147.105 105.203 146.244 106.064 146.244 107.127C146.244 108.189 147.105 109.05 148.168 109.05C149.23 109.05 150.091 108.189 150.091 107.127Z"
              fill="#005574"
            />
            <path
              d="M155.221 107.127C155.221 106.064 154.359 105.203 153.297 105.203C152.235 105.203 151.373 106.064 151.373 107.127C151.373 108.189 152.235 109.05 153.297 109.05C154.359 109.05 155.221 108.189 155.221 107.127Z"
              fill="#005574"
            />
            <path
              d="M160.35 107.127C160.35 106.064 159.489 105.203 158.427 105.203C157.364 105.203 156.503 106.064 156.503 107.127C156.503 108.189 157.364 109.05 158.427 109.05C159.489 109.05 160.35 108.189 160.35 107.127Z"
              fill="#005574"
            />
            <path
              d="M186 107.127C186 106.064 185.138 105.203 184.076 105.203C183.014 105.203 182.152 106.064 182.152 107.127C182.152 108.189 183.014 109.05 184.076 109.05C185.138 109.05 186 108.189 186 107.127Z"
              fill="#005574"
            />
            <path
              d="M21.8473 112.258C21.8473 111.196 20.9861 110.334 19.9237 110.334C18.8613 110.334 18 111.196 18 112.258C18 113.32 18.8613 114.182 19.9237 114.182C20.9861 114.182 21.8473 113.32 21.8473 112.258Z"
              fill="#005574"
            />
            <path
              d="M47.4958 112.258C47.4958 111.196 46.6345 110.334 45.5721 110.334C44.5097 110.334 43.6484 111.196 43.6484 112.258C43.6484 113.32 44.5097 114.182 45.5721 114.182C46.6345 114.182 47.4958 113.32 47.4958 112.258Z"
              fill="#005574"
            />
            <path
              d="M52.6255 112.258C52.6255 111.196 51.7642 110.334 50.7018 110.334C49.6394 110.334 48.7781 111.196 48.7781 112.258C48.7781 113.32 49.6394 114.182 50.7018 114.182C51.7642 114.182 52.6255 113.32 52.6255 112.258Z"
              fill="#005574"
            />
            <path
              d="M57.7552 112.258C57.7552 111.196 56.8939 110.334 55.8315 110.334C54.7691 110.334 53.9078 111.196 53.9078 112.258C53.9078 113.32 54.7691 114.182 55.8315 114.182C56.8939 114.182 57.7552 113.32 57.7552 112.258Z"
              fill="#005574"
            />
            <path
              d="M62.8848 112.258C62.8848 111.196 62.0235 110.334 60.9611 110.334C59.8987 110.334 59.0375 111.196 59.0375 112.258C59.0375 113.32 59.8987 114.182 60.9611 114.182C62.0235 114.182 62.8848 113.32 62.8848 112.258Z"
              fill="#005574"
            />
            <path
              d="M165.481 112.258C165.481 111.196 164.619 110.334 163.557 110.334C162.494 110.334 161.633 111.196 161.633 112.258C161.633 113.32 162.494 114.182 163.557 114.182C164.619 114.182 165.481 113.32 165.481 112.258Z"
              fill="#005574"
            />
            <path
              d="M175.74 112.258C175.74 111.196 174.879 110.334 173.816 110.334C172.754 110.334 171.893 111.196 171.893 112.258C171.893 113.32 172.754 114.182 173.816 114.182C174.879 114.182 175.74 113.32 175.74 112.258Z"
              fill="#005574"
            />
            <path
              d="M180.87 112.258C180.87 111.196 180.008 110.334 178.946 110.334C177.884 110.334 177.022 111.196 177.022 112.258C177.022 113.32 177.884 114.182 178.946 114.182C180.008 114.182 180.87 113.32 180.87 112.258Z"
              fill="#005574"
            />
            <path
              d="M21.8473 117.386C21.8473 116.324 20.9861 115.463 19.9237 115.463C18.8613 115.463 18 116.324 18 117.386C18 118.449 18.8613 119.31 19.9237 119.31C20.9861 119.31 21.8473 118.449 21.8473 117.386Z"
              fill="#005574"
            />
            <path
              d="M32.1067 117.386C32.1067 116.324 31.2455 115.463 30.1831 115.463C29.1207 115.463 28.2594 116.324 28.2594 117.386C28.2594 118.449 29.1207 119.31 30.1831 119.31C31.2455 119.31 32.1067 118.449 32.1067 117.386Z"
              fill="#005574"
            />
            <path
              d="M37.2364 117.386C37.2364 116.324 36.3751 115.463 35.3127 115.463C34.2503 115.463 33.389 116.324 33.389 117.386C33.389 118.449 34.2503 119.31 35.3127 119.31C36.3751 119.31 37.2364 118.449 37.2364 117.386Z"
              fill="#005574"
            />
            <path
              d="M42.3661 117.386C42.3661 116.324 41.5048 115.463 40.4424 115.463C39.38 115.463 38.5187 116.324 38.5187 117.386C38.5187 118.449 39.38 119.31 40.4424 119.31C41.5048 119.31 42.3661 118.449 42.3661 117.386Z"
              fill="#005574"
            />
            <path
              d="M62.8848 117.386C62.8848 116.324 62.0235 115.463 60.9611 115.463C59.8987 115.463 59.0375 116.324 59.0375 117.386C59.0375 118.449 59.8987 119.31 60.9611 119.31C62.0235 119.31 62.8848 118.449 62.8848 117.386Z"
              fill="#005574"
            />
            <path
              d="M68.0153 117.386C68.0153 116.324 67.154 115.463 66.0916 115.463C65.0292 115.463 64.168 116.324 64.168 117.386C64.168 118.449 65.0292 119.31 66.0916 119.31C67.154 119.31 68.0153 118.449 68.0153 117.386Z"
              fill="#005574"
            />
            <path
              d="M73.1442 117.386C73.1442 116.324 72.2829 115.463 71.2205 115.463C70.1581 115.463 69.2969 116.324 69.2969 117.386C69.2969 118.449 70.1581 119.31 71.2205 119.31C72.2829 119.31 73.1442 118.449 73.1442 117.386Z"
              fill="#005574"
            />
            <path
              d="M134.702 117.386C134.702 116.324 133.841 115.463 132.778 115.463C131.716 115.463 130.855 116.324 130.855 117.386C130.855 118.449 131.716 119.31 132.778 119.31C133.841 119.31 134.702 118.449 134.702 117.386Z"
              fill="#005574"
            />
            <path
              d="M139.832 117.386C139.832 116.324 138.97 115.463 137.908 115.463C136.846 115.463 135.984 116.324 135.984 117.386C135.984 118.449 136.846 119.31 137.908 119.31C138.97 119.31 139.832 118.449 139.832 117.386Z"
              fill="#005574"
            />
            <path
              d="M144.962 117.386C144.962 116.324 144.101 115.463 143.038 115.463C141.976 115.463 141.114 116.324 141.114 117.386C141.114 118.449 141.976 119.31 143.038 119.31C144.101 119.31 144.962 118.449 144.962 117.386Z"
              fill="#005574"
            />
            <path
              d="M150.091 117.386C150.091 116.324 149.23 115.463 148.168 115.463C147.105 115.463 146.244 116.324 146.244 117.386C146.244 118.449 147.105 119.31 148.168 119.31C149.23 119.31 150.091 118.449 150.091 117.386Z"
              fill="#005574"
            />
            <path
              d="M165.481 117.386C165.481 116.324 164.619 115.463 163.557 115.463C162.494 115.463 161.633 116.324 161.633 117.386C161.633 118.449 162.494 119.31 163.557 119.31C164.619 119.31 165.481 118.449 165.481 117.386Z"
              fill="#005574"
            />
            <path
              d="M170.61 117.386C170.61 116.324 169.749 115.463 168.687 115.463C167.624 115.463 166.763 116.324 166.763 117.386C166.763 118.449 167.624 119.31 168.687 119.31C169.749 119.31 170.61 118.449 170.61 117.386Z"
              fill="#005574"
            />
            <path
              d="M175.74 117.386C175.74 116.324 174.879 115.463 173.816 115.463C172.754 115.463 171.893 116.324 171.893 117.386C171.893 118.449 172.754 119.31 173.816 119.31C174.879 119.31 175.74 118.449 175.74 117.386Z"
              fill="#005574"
            />
            <path
              d="M186 117.386C186 116.324 185.138 115.463 184.076 115.463C183.014 115.463 182.152 116.324 182.152 117.386C182.152 118.449 183.014 119.31 184.076 119.31C185.138 119.31 186 118.449 186 117.386Z"
              fill="#005574"
            />
            <path
              d="M32.1067 122.517C32.1067 121.455 31.2455 120.594 30.1831 120.594C29.1207 120.594 28.2594 121.455 28.2594 122.517C28.2594 123.58 29.1207 124.441 30.1831 124.441C31.2455 124.441 32.1067 123.58 32.1067 122.517Z"
              fill="#005574"
            />
            <path
              d="M37.2364 122.517C37.2364 121.455 36.3751 120.594 35.3127 120.594C34.2503 120.594 33.389 121.455 33.389 122.517C33.389 123.58 34.2503 124.441 35.3127 124.441C36.3751 124.441 37.2364 123.58 37.2364 122.517Z"
              fill="#005574"
            />
            <path
              d="M47.4958 122.517C47.4958 121.455 46.6345 120.594 45.5721 120.594C44.5097 120.594 43.6484 121.455 43.6484 122.517C43.6484 123.58 44.5097 124.441 45.5721 124.441C46.6345 124.441 47.4958 123.58 47.4958 122.517Z"
              fill="#005574"
            />
            <path
              d="M52.6255 122.517C52.6255 121.455 51.7642 120.594 50.7018 120.594C49.6394 120.594 48.7781 121.455 48.7781 122.517C48.7781 123.58 49.6394 124.441 50.7018 124.441C51.7642 124.441 52.6255 123.58 52.6255 122.517Z"
              fill="#005574"
            />
            <path
              d="M57.7552 122.517C57.7552 121.455 56.8939 120.594 55.8315 120.594C54.7691 120.594 53.9078 121.455 53.9078 122.517C53.9078 123.58 54.7691 124.441 55.8315 124.441C56.8939 124.441 57.7552 123.58 57.7552 122.517Z"
              fill="#005574"
            />
            <path
              d="M68.0153 122.517C68.0153 121.455 67.154 120.594 66.0916 120.594C65.0292 120.594 64.168 121.455 64.168 122.517C64.168 123.58 65.0292 124.441 66.0916 124.441C67.154 124.441 68.0153 123.58 68.0153 122.517Z"
              fill="#005574"
            />
            <path
              d="M134.702 122.517C134.702 121.455 133.841 120.594 132.778 120.594C131.716 120.594 130.855 121.455 130.855 122.517C130.855 123.58 131.716 124.441 132.778 124.441C133.841 124.441 134.702 123.58 134.702 122.517Z"
              fill="#005574"
            />
            <path
              d="M144.962 122.517C144.962 121.455 144.101 120.594 143.038 120.594C141.976 120.594 141.114 121.455 141.114 122.517C141.114 123.58 141.976 124.441 143.038 124.441C144.101 124.441 144.962 123.58 144.962 122.517Z"
              fill="#005574"
            />
            <path
              d="M160.35 122.517C160.35 121.455 159.489 120.594 158.427 120.594C157.364 120.594 156.503 121.455 156.503 122.517C156.503 123.58 157.364 124.441 158.427 124.441C159.489 124.441 160.35 123.58 160.35 122.517Z"
              fill="#005574"
            />
            <path
              d="M165.481 122.517C165.481 121.455 164.619 120.594 163.557 120.594C162.494 120.594 161.633 121.455 161.633 122.517C161.633 123.58 162.494 124.441 163.557 124.441C164.619 124.441 165.481 123.58 165.481 122.517Z"
              fill="#005574"
            />
            <path
              d="M170.61 122.517C170.61 121.455 169.749 120.594 168.687 120.594C167.624 120.594 166.763 121.455 166.763 122.517C166.763 123.58 167.624 124.441 168.687 124.441C169.749 124.441 170.61 123.58 170.61 122.517Z"
              fill="#005574"
            />
            <path
              d="M21.8473 127.649C21.8473 126.586 20.9861 125.725 19.9237 125.725C18.8613 125.725 18 126.586 18 127.649C18 128.711 18.8613 129.572 19.9237 129.572C20.9861 129.572 21.8473 128.711 21.8473 127.649Z"
              fill="#005574"
            />
            <path
              d="M26.977 127.649C26.977 126.586 26.1158 125.725 25.0534 125.725C23.991 125.725 23.1297 126.586 23.1297 127.649C23.1297 128.711 23.991 129.572 25.0534 129.572C26.1158 129.572 26.977 128.711 26.977 127.649Z"
              fill="#005574"
            />
            <path
              d="M42.3661 127.649C42.3661 126.586 41.5048 125.725 40.4424 125.725C39.38 125.725 38.5187 126.586 38.5187 127.649C38.5187 128.711 39.38 129.572 40.4424 129.572C41.5048 129.572 42.3661 128.711 42.3661 127.649Z"
              fill="#005574"
            />
            <path
              d="M47.4958 127.649C47.4958 126.586 46.6345 125.725 45.5721 125.725C44.5097 125.725 43.6484 126.586 43.6484 127.649C43.6484 128.711 44.5097 129.572 45.5721 129.572C46.6345 129.572 47.4958 128.711 47.4958 127.649Z"
              fill="#005574"
            />
            <path
              d="M57.7552 127.649C57.7552 126.586 56.8939 125.725 55.8315 125.725C54.7691 125.725 53.9078 126.586 53.9078 127.649C53.9078 128.711 54.7691 129.572 55.8315 129.572C56.8939 129.572 57.7552 128.711 57.7552 127.649Z"
              fill="#005574"
            />
            <path
              d="M62.8848 127.649C62.8848 126.586 62.0235 125.725 60.9611 125.725C59.8987 125.725 59.0375 126.586 59.0375 127.649C59.0375 128.711 59.8987 129.572 60.9611 129.572C62.0235 129.572 62.8848 128.711 62.8848 127.649Z"
              fill="#005574"
            />
            <path
              d="M68.0153 127.649C68.0153 126.586 67.154 125.725 66.0916 125.725C65.0292 125.725 64.168 126.586 64.168 127.649C64.168 128.711 65.0292 129.572 66.0916 129.572C67.154 129.572 68.0153 128.711 68.0153 127.649Z"
              fill="#005574"
            />
            <path
              d="M134.702 127.649C134.702 126.586 133.841 125.725 132.778 125.725C131.716 125.725 130.855 126.586 130.855 127.649C130.855 128.711 131.716 129.572 132.778 129.572C133.841 129.572 134.702 128.711 134.702 127.649Z"
              fill="#005574"
            />
            <path
              d="M150.091 127.649C150.091 126.586 149.23 125.725 148.168 125.725C147.105 125.725 146.244 126.586 146.244 127.649C146.244 128.711 147.105 129.572 148.168 129.572C149.23 129.572 150.091 128.711 150.091 127.649Z"
              fill="#005574"
            />
            <path
              d="M170.61 127.649C170.61 126.586 169.749 125.725 168.687 125.725C167.624 125.725 166.763 126.586 166.763 127.649C166.763 128.711 167.624 129.572 168.687 129.572C169.749 129.572 170.61 128.711 170.61 127.649Z"
              fill="#005574"
            />
            <path
              d="M186 127.649C186 126.586 185.138 125.725 184.076 125.725C183.014 125.725 182.152 126.586 182.152 127.649C182.152 128.711 183.014 129.572 184.076 129.572C185.138 129.572 186 128.711 186 127.649Z"
              fill="#005574"
            />
            <path
              d="M21.8473 132.777C21.8473 131.714 20.9861 130.853 19.9237 130.853C18.8613 130.853 18 131.714 18 132.777C18 133.839 18.8613 134.7 19.9237 134.7C20.9861 134.7 21.8473 133.839 21.8473 132.777Z"
              fill="#005574"
            />
            <path
              d="M32.1067 132.777C32.1067 131.714 31.2455 130.853 30.1831 130.853C29.1207 130.853 28.2594 131.714 28.2594 132.777C28.2594 133.839 29.1207 134.7 30.1831 134.7C31.2455 134.7 32.1067 133.839 32.1067 132.777Z"
              fill="#005574"
            />
            <path
              d="M37.2364 132.777C37.2364 131.714 36.3751 130.853 35.3127 130.853C34.2503 130.853 33.389 131.714 33.389 132.777C33.389 133.839 34.2503 134.7 35.3127 134.7C36.3751 134.7 37.2364 133.839 37.2364 132.777Z"
              fill="#005574"
            />
            <path
              d="M52.6255 132.777C52.6255 131.714 51.7642 130.853 50.7018 130.853C49.6394 130.853 48.7781 131.714 48.7781 132.777C48.7781 133.839 49.6394 134.7 50.7018 134.7C51.7642 134.7 52.6255 133.839 52.6255 132.777Z"
              fill="#005574"
            />
            <path
              d="M62.8848 132.777C62.8848 131.714 62.0235 130.853 60.9611 130.853C59.8987 130.853 59.0375 131.714 59.0375 132.777C59.0375 133.839 59.8987 134.7 60.9611 134.7C62.0235 134.7 62.8848 133.839 62.8848 132.777Z"
              fill="#005574"
            />
            <path
              d="M73.1442 132.777C73.1442 131.714 72.2829 130.853 71.2205 130.853C70.1581 130.853 69.2969 131.714 69.2969 132.777C69.2969 133.839 70.1581 134.7 71.2205 134.7C72.2829 134.7 73.1442 133.839 73.1442 132.777Z"
              fill="#005574"
            />
            <path
              d="M78.2747 132.777C78.2747 131.714 77.4134 130.853 76.351 130.853C75.2886 130.853 74.4274 131.714 74.4274 132.777C74.4274 133.839 75.2886 134.7 76.351 134.7C77.4134 134.7 78.2747 133.839 78.2747 132.777Z"
              fill="#005574"
            />
            <path
              d="M83.4043 132.777C83.4043 131.714 82.5431 130.853 81.4807 130.853C80.4183 130.853 79.557 131.714 79.557 132.777C79.557 133.839 80.4183 134.7 81.4807 134.7C82.5431 134.7 83.4043 133.839 83.4043 132.777Z"
              fill="#005574"
            />
            <path
              d="M88.534 132.777C88.534 131.714 87.6728 130.853 86.6104 130.853C85.548 130.853 84.6867 131.714 84.6867 132.777C84.6867 133.839 85.548 134.7 86.6104 134.7C87.6728 134.7 88.534 133.839 88.534 132.777Z"
              fill="#005574"
            />
            <path
              d="M93.6637 132.777C93.6637 131.714 92.8025 130.853 91.7401 130.853C90.6777 130.853 89.8164 131.714 89.8164 132.777C89.8164 133.839 90.6777 134.7 91.7401 134.7C92.8025 134.7 93.6637 133.839 93.6637 132.777Z"
              fill="#005574"
            />
            <path
              d="M114.182 132.777C114.182 131.714 113.321 130.853 112.259 130.853C111.196 130.853 110.335 131.714 110.335 132.777C110.335 133.839 111.196 134.7 112.259 134.7C113.321 134.7 114.182 133.839 114.182 132.777Z"
              fill="#005574"
            />
            <path
              d="M124.443 132.777C124.443 131.714 123.581 130.853 122.519 130.853C121.457 130.853 120.595 131.714 120.595 132.777C120.595 133.839 121.457 134.7 122.519 134.7C123.581 134.7 124.443 133.839 124.443 132.777Z"
              fill="#005574"
            />
            <path
              d="M129.572 132.777C129.572 131.714 128.71 130.853 127.648 130.853C126.586 130.853 125.724 131.714 125.724 132.777C125.724 133.839 126.586 134.7 127.648 134.7C128.71 134.7 129.572 133.839 129.572 132.777Z"
              fill="#005574"
            />
            <path
              d="M134.702 132.777C134.702 131.714 133.841 130.853 132.778 130.853C131.716 130.853 130.855 131.714 130.855 132.777C130.855 133.839 131.716 134.7 132.778 134.7C133.841 134.7 134.702 133.839 134.702 132.777Z"
              fill="#005574"
            />
            <path
              d="M139.832 132.777C139.832 131.714 138.97 130.853 137.908 130.853C136.846 130.853 135.984 131.714 135.984 132.777C135.984 133.839 136.846 134.7 137.908 134.7C138.97 134.7 139.832 133.839 139.832 132.777Z"
              fill="#005574"
            />
            <path
              d="M144.962 132.777C144.962 131.714 144.101 130.853 143.038 130.853C141.976 130.853 141.114 131.714 141.114 132.777C141.114 133.839 141.976 134.7 143.038 134.7C144.101 134.7 144.962 133.839 144.962 132.777Z"
              fill="#005574"
            />
            <path
              d="M160.35 132.777C160.35 131.714 159.489 130.853 158.427 130.853C157.364 130.853 156.503 131.714 156.503 132.777C156.503 133.839 157.364 134.7 158.427 134.7C159.489 134.7 160.35 133.839 160.35 132.777Z"
              fill="#005574"
            />
            <path
              d="M165.481 132.777C165.481 131.714 164.619 130.853 163.557 130.853C162.494 130.853 161.633 131.714 161.633 132.777C161.633 133.839 162.494 134.7 163.557 134.7C164.619 134.7 165.481 133.839 165.481 132.777Z"
              fill="#005574"
            />
            <path
              d="M170.61 132.777C170.61 131.714 169.749 130.853 168.687 130.853C167.624 130.853 166.763 131.714 166.763 132.777C166.763 133.839 167.624 134.7 168.687 134.7C169.749 134.7 170.61 133.839 170.61 132.777Z"
              fill="#005574"
            />
            <path
              d="M180.87 132.777C180.87 131.714 180.008 130.853 178.946 130.853C177.884 130.853 177.022 131.714 177.022 132.777C177.022 133.839 177.884 134.7 178.946 134.7C180.008 134.7 180.87 133.839 180.87 132.777Z"
              fill="#005574"
            />
            <path
              d="M21.8473 137.908C21.8473 136.846 20.9861 135.984 19.9237 135.984C18.8613 135.984 18 136.846 18 137.908C18 138.97 18.8613 139.832 19.9237 139.832C20.9861 139.832 21.8473 138.97 21.8473 137.908Z"
              fill="#005574"
            />
            <path
              d="M37.2364 137.908C37.2364 136.846 36.3751 135.984 35.3127 135.984C34.2503 135.984 33.389 136.846 33.389 137.908C33.389 138.97 34.2503 139.832 35.3127 139.832C36.3751 139.832 37.2364 138.97 37.2364 137.908Z"
              fill="#005574"
            />
            <path
              d="M62.8848 137.908C62.8848 136.846 62.0235 135.984 60.9611 135.984C59.8987 135.984 59.0375 136.846 59.0375 137.908C59.0375 138.97 59.8987 139.832 60.9611 139.832C62.0235 139.832 62.8848 138.97 62.8848 137.908Z"
              fill="#005574"
            />
            <path
              d="M68.0153 137.908C68.0153 136.846 67.154 135.984 66.0916 135.984C65.0292 135.984 64.168 136.846 64.168 137.908C64.168 138.97 65.0292 139.832 66.0916 139.832C67.154 139.832 68.0153 138.97 68.0153 137.908Z"
              fill="#005574"
            />
            <path
              d="M83.4043 137.908C83.4043 136.846 82.5431 135.984 81.4807 135.984C80.4183 135.984 79.557 136.846 79.557 137.908C79.557 138.97 80.4183 139.832 81.4807 139.832C82.5431 139.832 83.4043 138.97 83.4043 137.908Z"
              fill="#005574"
            />
            <path
              d="M88.534 137.908C88.534 136.846 87.6728 135.984 86.6104 135.984C85.548 135.984 84.6867 136.846 84.6867 137.908C84.6867 138.97 85.548 139.832 86.6104 139.832C87.6728 139.832 88.534 138.97 88.534 137.908Z"
              fill="#005574"
            />
            <path
              d="M93.6637 137.908C93.6637 136.846 92.8025 135.984 91.7401 135.984C90.6777 135.984 89.8164 136.846 89.8164 137.908C89.8164 138.97 90.6777 139.832 91.7401 139.832C92.8025 139.832 93.6637 138.97 93.6637 137.908Z"
              fill="#005574"
            />
            <path
              d="M98.7942 137.908C98.7942 136.846 97.933 135.984 96.8706 135.984C95.8082 135.984 94.9469 136.846 94.9469 137.908C94.9469 138.97 95.8082 139.832 96.8706 139.832C97.933 139.832 98.7942 138.97 98.7942 137.908Z"
              fill="#005574"
            />
            <path
              d="M109.054 137.908C109.054 136.846 108.192 135.984 107.13 135.984C106.067 135.984 105.206 136.846 105.206 137.908C105.206 138.97 106.067 139.832 107.13 139.832C108.192 139.832 109.054 138.97 109.054 137.908Z"
              fill="#005574"
            />
            <path
              d="M119.312 137.908C119.312 136.846 118.451 135.984 117.389 135.984C116.326 135.984 115.465 136.846 115.465 137.908C115.465 138.97 116.326 139.832 117.389 139.832C118.451 139.832 119.312 138.97 119.312 137.908Z"
              fill="#005574"
            />
            <path
              d="M124.443 137.908C124.443 136.846 123.581 135.984 122.519 135.984C121.457 135.984 120.595 136.846 120.595 137.908C120.595 138.97 121.457 139.832 122.519 139.832C123.581 139.832 124.443 138.97 124.443 137.908Z"
              fill="#005574"
            />
            <path
              d="M129.572 137.908C129.572 136.846 128.71 135.984 127.648 135.984C126.586 135.984 125.724 136.846 125.724 137.908C125.724 138.97 126.586 139.832 127.648 139.832C128.71 139.832 129.572 138.97 129.572 137.908Z"
              fill="#005574"
            />
            <path
              d="M134.702 137.908C134.702 136.846 133.841 135.984 132.778 135.984C131.716 135.984 130.855 136.846 130.855 137.908C130.855 138.97 131.716 139.832 132.778 139.832C133.841 139.832 134.702 138.97 134.702 137.908Z"
              fill="#005574"
            />
            <path
              d="M139.832 137.908C139.832 136.846 138.97 135.984 137.908 135.984C136.846 135.984 135.984 136.846 135.984 137.908C135.984 138.97 136.846 139.832 137.908 139.832C138.97 139.832 139.832 138.97 139.832 137.908Z"
              fill="#005574"
            />
            <path
              d="M170.61 137.908C170.61 136.846 169.749 135.984 168.687 135.984C167.624 135.984 166.763 136.846 166.763 137.908C166.763 138.97 167.624 139.832 168.687 139.832C169.749 139.832 170.61 138.97 170.61 137.908Z"
              fill="#005574"
            />
            <path
              d="M175.74 137.908C175.74 136.846 174.879 135.984 173.816 135.984C172.754 135.984 171.893 136.846 171.893 137.908C171.893 138.97 172.754 139.832 173.816 139.832C174.879 139.832 175.74 138.97 175.74 137.908Z"
              fill="#005574"
            />
            <path
              d="M186 137.908C186 136.846 185.138 135.984 184.076 135.984C183.014 135.984 182.152 136.846 182.152 137.908C182.152 138.97 183.014 139.832 184.076 139.832C185.138 139.832 186 138.97 186 137.908Z"
              fill="#005574"
            />
            <path
              d="M21.8473 143.036C21.8473 141.974 20.9861 141.113 19.9237 141.113C18.8613 141.113 18 141.974 18 143.036C18 144.099 18.8613 144.96 19.9237 144.96C20.9861 144.96 21.8473 144.099 21.8473 143.036Z"
              fill="#005574"
            />
            <path
              d="M32.1067 143.036C32.1067 141.974 31.2455 141.113 30.1831 141.113C29.1207 141.113 28.2594 141.974 28.2594 143.036C28.2594 144.099 29.1207 144.96 30.1831 144.96C31.2455 144.96 32.1067 144.099 32.1067 143.036Z"
              fill="#005574"
            />
            <path
              d="M37.2364 143.036C37.2364 141.974 36.3751 141.113 35.3127 141.113C34.2503 141.113 33.389 141.974 33.389 143.036C33.389 144.099 34.2503 144.96 35.3127 144.96C36.3751 144.96 37.2364 144.099 37.2364 143.036Z"
              fill="#005574"
            />
            <path
              d="M52.6255 143.036C52.6255 141.974 51.7642 141.113 50.7018 141.113C49.6394 141.113 48.7781 141.974 48.7781 143.036C48.7781 144.099 49.6394 144.96 50.7018 144.96C51.7642 144.96 52.6255 144.099 52.6255 143.036Z"
              fill="#005574"
            />
            <path
              d="M57.7552 143.036C57.7552 141.974 56.8939 141.113 55.8315 141.113C54.7691 141.113 53.9078 141.974 53.9078 143.036C53.9078 144.099 54.7691 144.96 55.8315 144.96C56.8939 144.96 57.7552 144.099 57.7552 143.036Z"
              fill="#005574"
            />
            <path
              d="M68.0153 143.036C68.0153 141.974 67.154 141.113 66.0916 141.113C65.0292 141.113 64.168 141.974 64.168 143.036C64.168 144.099 65.0292 144.96 66.0916 144.96C67.154 144.96 68.0153 144.099 68.0153 143.036Z"
              fill="#005574"
            />
            <path
              d="M73.1442 143.036C73.1442 141.974 72.2829 141.113 71.2205 141.113C70.1581 141.113 69.2969 141.974 69.2969 143.036C69.2969 144.099 70.1581 144.96 71.2205 144.96C72.2829 144.96 73.1442 144.099 73.1442 143.036Z"
              fill="#005574"
            />
            <path
              d="M98.7942 143.036C98.7942 141.974 97.933 141.113 96.8706 141.113C95.8082 141.113 94.9469 141.974 94.9469 143.036C94.9469 144.099 95.8082 144.96 96.8706 144.96C97.933 144.96 98.7942 144.099 98.7942 143.036Z"
              fill="#005574"
            />
            <path
              d="M103.923 143.036C103.923 141.974 103.062 141.113 101.999 141.113C100.937 141.113 100.076 141.974 100.076 143.036C100.076 144.099 100.937 144.96 101.999 144.96C103.062 144.96 103.923 144.099 103.923 143.036Z"
              fill="#005574"
            />
            <path
              d="M109.054 143.036C109.054 141.974 108.192 141.113 107.13 141.113C106.067 141.113 105.206 141.974 105.206 143.036C105.206 144.099 106.067 144.96 107.13 144.96C108.192 144.96 109.054 144.099 109.054 143.036Z"
              fill="#005574"
            />
            <path
              d="M134.702 143.036C134.702 141.974 133.841 141.113 132.778 141.113C131.716 141.113 130.855 141.974 130.855 143.036C130.855 144.099 131.716 144.96 132.778 144.96C133.841 144.96 134.702 144.099 134.702 143.036Z"
              fill="#005574"
            />
            <path
              d="M139.832 143.036C139.832 141.974 138.97 141.113 137.908 141.113C136.846 141.113 135.984 141.974 135.984 143.036C135.984 144.099 136.846 144.96 137.908 144.96C138.97 144.96 139.832 144.099 139.832 143.036Z"
              fill="#005574"
            />
            <path
              d="M144.962 143.036C144.962 141.974 144.101 141.113 143.038 141.113C141.976 141.113 141.114 141.974 141.114 143.036C141.114 144.099 141.976 144.96 143.038 144.96C144.101 144.96 144.962 144.099 144.962 143.036Z"
              fill="#005574"
            />
            <path
              d="M150.091 143.036C150.091 141.974 149.23 141.113 148.168 141.113C147.105 141.113 146.244 141.974 146.244 143.036C146.244 144.099 147.105 144.96 148.168 144.96C149.23 144.96 150.091 144.099 150.091 143.036Z"
              fill="#005574"
            />
            <path
              d="M155.221 143.036C155.221 141.974 154.359 141.113 153.297 141.113C152.235 141.113 151.373 141.974 151.373 143.036C151.373 144.099 152.235 144.96 153.297 144.96C154.359 144.96 155.221 144.099 155.221 143.036Z"
              fill="#005574"
            />
            <path
              d="M160.35 143.036C160.35 141.974 159.489 141.113 158.427 141.113C157.364 141.113 156.503 141.974 156.503 143.036C156.503 144.099 157.364 144.96 158.427 144.96C159.489 144.96 160.35 144.099 160.35 143.036Z"
              fill="#005574"
            />
            <path
              d="M165.481 143.036C165.481 141.974 164.619 141.113 163.557 141.113C162.494 141.113 161.633 141.974 161.633 143.036C161.633 144.099 162.494 144.96 163.557 144.96C164.619 144.96 165.481 144.099 165.481 143.036Z"
              fill="#005574"
            />
            <path
              d="M170.61 143.036C170.61 141.974 169.749 141.113 168.687 141.113C167.624 141.113 166.763 141.974 166.763 143.036C166.763 144.099 167.624 144.96 168.687 144.96C169.749 144.96 170.61 144.099 170.61 143.036Z"
              fill="#005574"
            />
            <path
              d="M62.8848 148.167C62.8848 147.105 62.0235 146.244 60.9611 146.244C59.8987 146.244 59.0375 147.105 59.0375 148.167C59.0375 149.23 59.8987 150.091 60.9611 150.091C62.0235 150.091 62.8848 149.23 62.8848 148.167Z"
              fill="#005574"
            />
            <path
              d="M78.2747 148.167C78.2747 147.105 77.4134 146.244 76.351 146.244C75.2886 146.244 74.4274 147.105 74.4274 148.167C74.4274 149.23 75.2886 150.091 76.351 150.091C77.4134 150.091 78.2747 149.23 78.2747 148.167Z"
              fill="#005574"
            />
            <path
              d="M83.4043 148.167C83.4043 147.105 82.5431 146.244 81.4807 146.244C80.4183 146.244 79.557 147.105 79.557 148.167C79.557 149.23 80.4183 150.091 81.4807 150.091C82.5431 150.091 83.4043 149.23 83.4043 148.167Z"
              fill="#005574"
            />
            <path
              d="M93.6637 148.167C93.6637 147.105 92.8025 146.244 91.7401 146.244C90.6777 146.244 89.8164 147.105 89.8164 148.167C89.8164 149.23 90.6777 150.091 91.7401 150.091C92.8025 150.091 93.6637 149.23 93.6637 148.167Z"
              fill="#005574"
            />
            <path
              d="M98.7942 148.167C98.7942 147.105 97.933 146.244 96.8706 146.244C95.8082 146.244 94.9469 147.105 94.9469 148.167C94.9469 149.23 95.8082 150.091 96.8706 150.091C97.933 150.091 98.7942 149.23 98.7942 148.167Z"
              fill="#005574"
            />
            <path
              d="M103.923 148.167C103.923 147.105 103.062 146.244 101.999 146.244C100.937 146.244 100.076 147.105 100.076 148.167C100.076 149.23 100.937 150.091 101.999 150.091C103.062 150.091 103.923 149.23 103.923 148.167Z"
              fill="#005574"
            />
            <path
              d="M109.054 148.167C109.054 147.105 108.192 146.244 107.13 146.244C106.067 146.244 105.206 147.105 105.206 148.167C105.206 149.23 106.067 150.091 107.13 150.091C108.192 150.091 109.054 149.23 109.054 148.167Z"
              fill="#005574"
            />
            <path
              d="M114.182 148.167C114.182 147.105 113.321 146.244 112.259 146.244C111.196 146.244 110.335 147.105 110.335 148.167C110.335 149.23 111.196 150.091 112.259 150.091C113.321 150.091 114.182 149.23 114.182 148.167Z"
              fill="#005574"
            />
            <path
              d="M124.443 148.167C124.443 147.105 123.581 146.244 122.519 146.244C121.457 146.244 120.595 147.105 120.595 148.167C120.595 149.23 121.457 150.091 122.519 150.091C123.581 150.091 124.443 149.23 124.443 148.167Z"
              fill="#005574"
            />
            <path
              d="M129.572 148.167C129.572 147.105 128.71 146.244 127.648 146.244C126.586 146.244 125.724 147.105 125.724 148.167C125.724 149.23 126.586 150.091 127.648 150.091C128.71 150.091 129.572 149.23 129.572 148.167Z"
              fill="#005574"
            />
            <path
              d="M139.832 148.167C139.832 147.105 138.97 146.244 137.908 146.244C136.846 146.244 135.984 147.105 135.984 148.167C135.984 149.23 136.846 150.091 137.908 150.091C138.97 150.091 139.832 149.23 139.832 148.167Z"
              fill="#005574"
            />
            <path
              d="M144.962 148.167C144.962 147.105 144.101 146.244 143.038 146.244C141.976 146.244 141.114 147.105 141.114 148.167C141.114 149.23 141.976 150.091 143.038 150.091C144.101 150.091 144.962 149.23 144.962 148.167Z"
              fill="#005574"
            />
            <path
              d="M165.481 148.167C165.481 147.105 164.619 146.244 163.557 146.244C162.494 146.244 161.633 147.105 161.633 148.167C161.633 149.23 162.494 150.091 163.557 150.091C164.619 150.091 165.481 149.23 165.481 148.167Z"
              fill="#005574"
            />
            <path
              d="M175.74 148.167C175.74 147.105 174.879 146.244 173.816 146.244C172.754 146.244 171.893 147.105 171.893 148.167C171.893 149.23 172.754 150.091 173.816 150.091C174.879 150.091 175.74 149.23 175.74 148.167Z"
              fill="#005574"
            />
            <path
              d="M186 148.167C186 147.105 185.138 146.244 184.076 146.244C183.014 146.244 182.152 147.105 182.152 148.167C182.152 149.23 183.014 150.091 184.076 150.091C185.138 150.091 186 149.23 186 148.167Z"
              fill="#005574"
            />
            <path
              d="M88.534 153.299C88.534 152.236 87.6728 151.375 86.6104 151.375C85.548 151.375 84.6867 152.236 84.6867 153.299C84.6867 154.361 85.548 155.222 86.6104 155.222C87.6728 155.222 88.534 154.361 88.534 153.299Z"
              fill="#005574"
            />
            <path
              d="M93.6637 153.299C93.6637 152.236 92.8025 151.375 91.7401 151.375C90.6777 151.375 89.8164 152.236 89.8164 153.299C89.8164 154.361 90.6777 155.222 91.7401 155.222C92.8025 155.222 93.6637 154.361 93.6637 153.299Z"
              fill="#005574"
            />
            <path
              d="M109.054 153.299C109.054 152.236 108.192 151.375 107.13 151.375C106.067 151.375 105.206 152.236 105.206 153.299C105.206 154.361 106.067 155.222 107.13 155.222C108.192 155.222 109.054 154.361 109.054 153.299Z"
              fill="#005574"
            />
            <path
              d="M124.443 153.299C124.443 152.236 123.581 151.375 122.519 151.375C121.457 151.375 120.595 152.236 120.595 153.299C120.595 154.361 121.457 155.222 122.519 155.222C123.581 155.222 124.443 154.361 124.443 153.299Z"
              fill="#005574"
            />
            <path
              d="M129.572 153.299C129.572 152.236 128.71 151.375 127.648 151.375C126.586 151.375 125.724 152.236 125.724 153.299C125.724 154.361 126.586 155.222 127.648 155.222C128.71 155.222 129.572 154.361 129.572 153.299Z"
              fill="#005574"
            />
            <path
              d="M139.832 153.299C139.832 152.236 138.97 151.375 137.908 151.375C136.846 151.375 135.984 152.236 135.984 153.299C135.984 154.361 136.846 155.222 137.908 155.222C138.97 155.222 139.832 154.361 139.832 153.299Z"
              fill="#005574"
            />
            <path
              d="M144.962 153.299C144.962 152.236 144.101 151.375 143.038 151.375C141.976 151.375 141.114 152.236 141.114 153.299C141.114 154.361 141.976 155.222 143.038 155.222C144.101 155.222 144.962 154.361 144.962 153.299Z"
              fill="#005574"
            />
            <path
              d="M155.221 153.299C155.221 152.236 154.359 151.375 153.297 151.375C152.235 151.375 151.373 152.236 151.373 153.299C151.373 154.361 152.235 155.222 153.297 155.222C154.359 155.222 155.221 154.361 155.221 153.299Z"
              fill="#005574"
            />
            <path
              d="M165.481 153.299C165.481 152.236 164.619 151.375 163.557 151.375C162.494 151.375 161.633 152.236 161.633 153.299C161.633 154.361 162.494 155.222 163.557 155.222C164.619 155.222 165.481 154.361 165.481 153.299Z"
              fill="#005574"
            />
            <path
              d="M170.61 153.299C170.61 152.236 169.749 151.375 168.687 151.375C167.624 151.375 166.763 152.236 166.763 153.299C166.763 154.361 167.624 155.222 168.687 155.222C169.749 155.222 170.61 154.361 170.61 153.299Z"
              fill="#005574"
            />
            <path
              d="M180.87 153.299C180.87 152.236 180.008 151.375 178.946 151.375C177.884 151.375 177.022 152.236 177.022 153.299C177.022 154.361 177.884 155.222 178.946 155.222C180.008 155.222 180.87 154.361 180.87 153.299Z"
              fill="#005574"
            />
            <path
              d="M73.1442 158.427C73.1442 157.364 72.2829 156.503 71.2205 156.503C70.1581 156.503 69.2969 157.364 69.2969 158.427C69.2969 159.489 70.1581 160.35 71.2205 160.35C72.2829 160.35 73.1442 159.489 73.1442 158.427Z"
              fill="#005574"
            />
            <path
              d="M83.4043 158.427C83.4043 157.364 82.5431 156.503 81.4807 156.503C80.4183 156.503 79.557 157.364 79.557 158.427C79.557 159.489 80.4183 160.35 81.4807 160.35C82.5431 160.35 83.4043 159.489 83.4043 158.427Z"
              fill="#005574"
            />
            <path
              d="M103.923 158.427C103.923 157.364 103.062 156.503 101.999 156.503C100.937 156.503 100.076 157.364 100.076 158.427C100.076 159.489 100.937 160.35 101.999 160.35C103.062 160.35 103.923 159.489 103.923 158.427Z"
              fill="#005574"
            />
            <path
              d="M109.054 158.427C109.054 157.364 108.192 156.503 107.13 156.503C106.067 156.503 105.206 157.364 105.206 158.427C105.206 159.489 106.067 160.35 107.13 160.35C108.192 160.35 109.054 159.489 109.054 158.427Z"
              fill="#005574"
            />
            <path
              d="M119.312 158.427C119.312 157.364 118.451 156.503 117.389 156.503C116.326 156.503 115.465 157.364 115.465 158.427C115.465 159.489 116.326 160.35 117.389 160.35C118.451 160.35 119.312 159.489 119.312 158.427Z"
              fill="#005574"
            />
            <path
              d="M129.572 158.427C129.572 157.364 128.71 156.503 127.648 156.503C126.586 156.503 125.724 157.364 125.724 158.427C125.724 159.489 126.586 160.35 127.648 160.35C128.71 160.35 129.572 159.489 129.572 158.427Z"
              fill="#005574"
            />
            <path
              d="M134.702 158.427C134.702 157.364 133.841 156.503 132.778 156.503C131.716 156.503 130.855 157.364 130.855 158.427C130.855 159.489 131.716 160.35 132.778 160.35C133.841 160.35 134.702 159.489 134.702 158.427Z"
              fill="#005574"
            />
            <path
              d="M144.962 158.427C144.962 157.364 144.101 156.503 143.038 156.503C141.976 156.503 141.114 157.364 141.114 158.427C141.114 159.489 141.976 160.35 143.038 160.35C144.101 160.35 144.962 159.489 144.962 158.427Z"
              fill="#005574"
            />
            <path
              d="M165.481 158.427C165.481 157.364 164.619 156.503 163.557 156.503C162.494 156.503 161.633 157.364 161.633 158.427C161.633 159.489 162.494 160.35 163.557 160.35C164.619 160.35 165.481 159.489 165.481 158.427Z"
              fill="#005574"
            />
            <path
              d="M175.74 158.427C175.74 157.364 174.879 156.503 173.816 156.503C172.754 156.503 171.893 157.364 171.893 158.427C171.893 159.489 172.754 160.35 173.816 160.35C174.879 160.35 175.74 159.489 175.74 158.427Z"
              fill="#005574"
            />
            <path
              d="M180.87 158.427C180.87 157.364 180.008 156.503 178.946 156.503C177.884 156.503 177.022 157.364 177.022 158.427C177.022 159.489 177.884 160.35 178.946 160.35C180.008 160.35 180.87 159.489 180.87 158.427Z"
              fill="#005574"
            />
            <path
              d="M186 158.427C186 157.364 185.138 156.503 184.076 156.503C183.014 156.503 182.152 157.364 182.152 158.427C182.152 159.489 183.014 160.35 184.076 160.35C185.138 160.35 186 159.489 186 158.427Z"
              fill="#005574"
            />
            <path
              d="M62.8848 163.555C62.8848 162.493 62.0235 161.631 60.9611 161.631C59.8987 161.631 59.0375 162.493 59.0375 163.555C59.0375 164.617 59.8987 165.479 60.9611 165.479C62.0235 165.479 62.8848 164.617 62.8848 163.555Z"
              fill="#005574"
            />
            <path
              d="M83.4043 163.555C83.4043 162.493 82.5431 161.631 81.4807 161.631C80.4183 161.631 79.557 162.493 79.557 163.555C79.557 164.617 80.4183 165.479 81.4807 165.479C82.5431 165.479 83.4043 164.617 83.4043 163.555Z"
              fill="#005574"
            />
            <path
              d="M88.534 163.555C88.534 162.493 87.6728 161.631 86.6104 161.631C85.548 161.631 84.6867 162.493 84.6867 163.555C84.6867 164.617 85.548 165.479 86.6104 165.479C87.6728 165.479 88.534 164.617 88.534 163.555Z"
              fill="#005574"
            />
            <path
              d="M98.7942 163.555C98.7942 162.493 97.933 161.631 96.8706 161.631C95.8082 161.631 94.9469 162.493 94.9469 163.555C94.9469 164.617 95.8082 165.479 96.8706 165.479C97.933 165.479 98.7942 164.617 98.7942 163.555Z"
              fill="#005574"
            />
            <path
              d="M103.923 163.555C103.923 162.493 103.062 161.631 101.999 161.631C100.937 161.631 100.076 162.493 100.076 163.555C100.076 164.617 100.937 165.479 101.999 165.479C103.062 165.479 103.923 164.617 103.923 163.555Z"
              fill="#005574"
            />
            <path
              d="M109.054 163.555C109.054 162.493 108.192 161.631 107.13 161.631C106.067 161.631 105.206 162.493 105.206 163.555C105.206 164.617 106.067 165.479 107.13 165.479C108.192 165.479 109.054 164.617 109.054 163.555Z"
              fill="#005574"
            />
            <path
              d="M129.572 163.555C129.572 162.493 128.71 161.631 127.648 161.631C126.586 161.631 125.724 162.493 125.724 163.555C125.724 164.617 126.586 165.479 127.648 165.479C128.71 165.479 129.572 164.617 129.572 163.555Z"
              fill="#005574"
            />
            <path
              d="M144.962 163.555C144.962 162.493 144.101 161.631 143.038 161.631C141.976 161.631 141.114 162.493 141.114 163.555C141.114 164.617 141.976 165.479 143.038 165.479C144.101 165.479 144.962 164.617 144.962 163.555Z"
              fill="#005574"
            />
            <path
              d="M150.091 163.555C150.091 162.493 149.23 161.631 148.168 161.631C147.105 161.631 146.244 162.493 146.244 163.555C146.244 164.617 147.105 165.479 148.168 165.479C149.23 165.479 150.091 164.617 150.091 163.555Z"
              fill="#005574"
            />
            <path
              d="M155.221 163.555C155.221 162.493 154.359 161.631 153.297 161.631C152.235 161.631 151.373 162.493 151.373 163.555C151.373 164.617 152.235 165.479 153.297 165.479C154.359 165.479 155.221 164.617 155.221 163.555Z"
              fill="#005574"
            />
            <path
              d="M160.35 163.555C160.35 162.493 159.489 161.631 158.427 161.631C157.364 161.631 156.503 162.493 156.503 163.555C156.503 164.617 157.364 165.479 158.427 165.479C159.489 165.479 160.35 164.617 160.35 163.555Z"
              fill="#005574"
            />
            <path
              d="M165.481 163.555C165.481 162.493 164.619 161.631 163.557 161.631C162.494 161.631 161.633 162.493 161.633 163.555C161.633 164.617 162.494 165.479 163.557 165.479C164.619 165.479 165.481 164.617 165.481 163.555Z"
              fill="#005574"
            />
            <path
              d="M180.87 163.555C180.87 162.493 180.008 161.631 178.946 161.631C177.884 161.631 177.022 162.493 177.022 163.555C177.022 164.617 177.884 165.479 178.946 165.479C180.008 165.479 180.87 164.617 180.87 163.555Z"
              fill="#005574"
            />
            <path
              d="M186 163.555C186 162.493 185.138 161.631 184.076 161.631C183.014 161.631 182.152 162.493 182.152 163.555C182.152 164.617 183.014 165.479 184.076 165.479C185.138 165.479 186 164.617 186 163.555Z"
              fill="#005574"
            />
            <path
              d="M62.8848 168.686C62.8848 167.624 62.0235 166.762 60.9611 166.762C59.8987 166.762 59.0375 167.624 59.0375 168.686C59.0375 169.749 59.8987 170.61 60.9611 170.61C62.0235 170.61 62.8848 169.749 62.8848 168.686Z"
              fill="#005574"
            />
            <path
              d="M68.0153 168.686C68.0153 167.624 67.154 166.762 66.0916 166.762C65.0292 166.762 64.168 167.624 64.168 168.686C64.168 169.749 65.0292 170.61 66.0916 170.61C67.154 170.61 68.0153 169.749 68.0153 168.686Z"
              fill="#005574"
            />
            <path
              d="M78.2747 168.686C78.2747 167.624 77.4134 166.762 76.351 166.762C75.2886 166.762 74.4274 167.624 74.4274 168.686C74.4274 169.749 75.2886 170.61 76.351 170.61C77.4134 170.61 78.2747 169.749 78.2747 168.686Z"
              fill="#005574"
            />
            <path
              d="M88.534 168.686C88.534 167.624 87.6728 166.762 86.6104 166.762C85.548 166.762 84.6867 167.624 84.6867 168.686C84.6867 169.749 85.548 170.61 86.6104 170.61C87.6728 170.61 88.534 169.749 88.534 168.686Z"
              fill="#005574"
            />
            <path
              d="M93.6637 168.686C93.6637 167.624 92.8025 166.762 91.7401 166.762C90.6777 166.762 89.8164 167.624 89.8164 168.686C89.8164 169.749 90.6777 170.61 91.7401 170.61C92.8025 170.61 93.6637 169.749 93.6637 168.686Z"
              fill="#005574"
            />
            <path
              d="M98.7942 168.686C98.7942 167.624 97.933 166.762 96.8706 166.762C95.8082 166.762 94.9469 167.624 94.9469 168.686C94.9469 169.749 95.8082 170.61 96.8706 170.61C97.933 170.61 98.7942 169.749 98.7942 168.686Z"
              fill="#005574"
            />
            <path
              d="M119.312 168.686C119.312 167.624 118.451 166.762 117.389 166.762C116.326 166.762 115.465 167.624 115.465 168.686C115.465 169.749 116.326 170.61 117.389 170.61C118.451 170.61 119.312 169.749 119.312 168.686Z"
              fill="#005574"
            />
            <path
              d="M124.443 168.686C124.443 167.624 123.581 166.762 122.519 166.762C121.457 166.762 120.595 167.624 120.595 168.686C120.595 169.749 121.457 170.61 122.519 170.61C123.581 170.61 124.443 169.749 124.443 168.686Z"
              fill="#005574"
            />
            <path
              d="M134.702 168.686C134.702 167.624 133.841 166.762 132.778 166.762C131.716 166.762 130.855 167.624 130.855 168.686C130.855 169.749 131.716 170.61 132.778 170.61C133.841 170.61 134.702 169.749 134.702 168.686Z"
              fill="#005574"
            />
            <path
              d="M139.832 168.686C139.832 167.624 138.97 166.762 137.908 166.762C136.846 166.762 135.984 167.624 135.984 168.686C135.984 169.749 136.846 170.61 137.908 170.61C138.97 170.61 139.832 169.749 139.832 168.686Z"
              fill="#005574"
            />
            <path
              d="M150.091 168.686C150.091 167.624 149.23 166.762 148.168 166.762C147.105 166.762 146.244 167.624 146.244 168.686C146.244 169.749 147.105 170.61 148.168 170.61C149.23 170.61 150.091 169.749 150.091 168.686Z"
              fill="#005574"
            />
            <path
              d="M165.481 168.686C165.481 167.624 164.619 166.762 163.557 166.762C162.494 166.762 161.633 167.624 161.633 168.686C161.633 169.749 162.494 170.61 163.557 170.61C164.619 170.61 165.481 169.749 165.481 168.686Z"
              fill="#005574"
            />
            <path
              d="M175.74 168.686C175.74 167.624 174.879 166.762 173.816 166.762C172.754 166.762 171.893 167.624 171.893 168.686C171.893 169.749 172.754 170.61 173.816 170.61C174.879 170.61 175.74 169.749 175.74 168.686Z"
              fill="#005574"
            />
            <path
              d="M180.87 168.686C180.87 167.624 180.008 166.762 178.946 166.762C177.884 166.762 177.022 167.624 177.022 168.686C177.022 169.749 177.884 170.61 178.946 170.61C180.008 170.61 180.87 169.749 180.87 168.686Z"
              fill="#005574"
            />
            <path
              d="M62.8848 173.814C62.8848 172.752 62.0235 171.891 60.9611 171.891C59.8987 171.891 59.0375 172.752 59.0375 173.814C59.0375 174.877 59.8987 175.738 60.9611 175.738C62.0235 175.738 62.8848 174.877 62.8848 173.814Z"
              fill="#005574"
            />
            <path
              d="M68.0153 173.814C68.0153 172.752 67.154 171.891 66.0916 171.891C65.0292 171.891 64.168 172.752 64.168 173.814C64.168 174.877 65.0292 175.738 66.0916 175.738C67.154 175.738 68.0153 174.877 68.0153 173.814Z"
              fill="#005574"
            />
            <path
              d="M73.1442 173.814C73.1442 172.752 72.2829 171.891 71.2205 171.891C70.1581 171.891 69.2969 172.752 69.2969 173.814C69.2969 174.877 70.1581 175.738 71.2205 175.738C72.2829 175.738 73.1442 174.877 73.1442 173.814Z"
              fill="#005574"
            />
            <path
              d="M78.2747 173.814C78.2747 172.752 77.4134 171.891 76.351 171.891C75.2886 171.891 74.4274 172.752 74.4274 173.814C74.4274 174.877 75.2886 175.738 76.351 175.738C77.4134 175.738 78.2747 174.877 78.2747 173.814Z"
              fill="#005574"
            />
            <path
              d="M83.4043 173.814C83.4043 172.752 82.5431 171.891 81.4807 171.891C80.4183 171.891 79.557 172.752 79.557 173.814C79.557 174.877 80.4183 175.738 81.4807 175.738C82.5431 175.738 83.4043 174.877 83.4043 173.814Z"
              fill="#005574"
            />
            <path
              d="M103.923 173.814C103.923 172.752 103.062 171.891 101.999 171.891C100.937 171.891 100.076 172.752 100.076 173.814C100.076 174.877 100.937 175.738 101.999 175.738C103.062 175.738 103.923 174.877 103.923 173.814Z"
              fill="#005574"
            />
            <path
              d="M124.443 173.814C124.443 172.752 123.581 171.891 122.519 171.891C121.457 171.891 120.595 172.752 120.595 173.814C120.595 174.877 121.457 175.738 122.519 175.738C123.581 175.738 124.443 174.877 124.443 173.814Z"
              fill="#005574"
            />
            <path
              d="M144.962 173.814C144.962 172.752 144.101 171.891 143.038 171.891C141.976 171.891 141.114 172.752 141.114 173.814C141.114 174.877 141.976 175.738 143.038 175.738C144.101 175.738 144.962 174.877 144.962 173.814Z"
              fill="#005574"
            />
            <path
              d="M150.091 173.814C150.091 172.752 149.23 171.891 148.168 171.891C147.105 171.891 146.244 172.752 146.244 173.814C146.244 174.877 147.105 175.738 148.168 175.738C149.23 175.738 150.091 174.877 150.091 173.814Z"
              fill="#005574"
            />
            <path
              d="M155.221 173.814C155.221 172.752 154.359 171.891 153.297 171.891C152.235 171.891 151.373 172.752 151.373 173.814C151.373 174.877 152.235 175.738 153.297 175.738C154.359 175.738 155.221 174.877 155.221 173.814Z"
              fill="#005574"
            />
            <path
              d="M170.61 173.814C170.61 172.752 169.749 171.891 168.687 171.891C167.624 171.891 166.763 172.752 166.763 173.814C166.763 174.877 167.624 175.738 168.687 175.738C169.749 175.738 170.61 174.877 170.61 173.814Z"
              fill="#005574"
            />
            <path
              d="M175.74 173.814C175.74 172.752 174.879 171.891 173.816 171.891C172.754 171.891 171.893 172.752 171.893 173.814C171.893 174.877 172.754 175.738 173.816 175.738C174.879 175.738 175.74 174.877 175.74 173.814Z"
              fill="#005574"
            />
            <path
              d="M73.1442 178.946C73.1442 177.883 72.2829 177.022 71.2205 177.022C70.1581 177.022 69.2969 177.883 69.2969 178.946C69.2969 180.008 70.1581 180.869 71.2205 180.869C72.2829 180.869 73.1442 180.008 73.1442 178.946Z"
              fill="#005574"
            />
            <path
              d="M78.2747 178.946C78.2747 177.883 77.4134 177.022 76.351 177.022C75.2886 177.022 74.4274 177.883 74.4274 178.946C74.4274 180.008 75.2886 180.869 76.351 180.869C77.4134 180.869 78.2747 180.008 78.2747 178.946Z"
              fill="#005574"
            />
            <path
              d="M88.534 178.946C88.534 177.883 87.6728 177.022 86.6104 177.022C85.548 177.022 84.6867 177.883 84.6867 178.946C84.6867 180.008 85.548 180.869 86.6104 180.869C87.6728 180.869 88.534 180.008 88.534 178.946Z"
              fill="#005574"
            />
            <path
              d="M93.6637 178.946C93.6637 177.883 92.8025 177.022 91.7401 177.022C90.6777 177.022 89.8164 177.883 89.8164 178.946C89.8164 180.008 90.6777 180.869 91.7401 180.869C92.8025 180.869 93.6637 180.008 93.6637 178.946Z"
              fill="#005574"
            />
            <path
              d="M98.7942 178.946C98.7942 177.883 97.933 177.022 96.8706 177.022C95.8082 177.022 94.9469 177.883 94.9469 178.946C94.9469 180.008 95.8082 180.869 96.8706 180.869C97.933 180.869 98.7942 180.008 98.7942 178.946Z"
              fill="#005574"
            />
            <path
              d="M103.923 178.946C103.923 177.883 103.062 177.022 101.999 177.022C100.937 177.022 100.076 177.883 100.076 178.946C100.076 180.008 100.937 180.869 101.999 180.869C103.062 180.869 103.923 180.008 103.923 178.946Z"
              fill="#005574"
            />
            <path
              d="M114.182 178.946C114.182 177.883 113.321 177.022 112.259 177.022C111.196 177.022 110.335 177.883 110.335 178.946C110.335 180.008 111.196 180.869 112.259 180.869C113.321 180.869 114.182 180.008 114.182 178.946Z"
              fill="#005574"
            />
            <path
              d="M124.443 178.946C124.443 177.883 123.581 177.022 122.519 177.022C121.457 177.022 120.595 177.883 120.595 178.946C120.595 180.008 121.457 180.869 122.519 180.869C123.581 180.869 124.443 180.008 124.443 178.946Z"
              fill="#005574"
            />
            <path
              d="M129.572 178.946C129.572 177.883 128.71 177.022 127.648 177.022C126.586 177.022 125.724 177.883 125.724 178.946C125.724 180.008 126.586 180.869 127.648 180.869C128.71 180.869 129.572 180.008 129.572 178.946Z"
              fill="#005574"
            />
            <path
              d="M134.702 178.946C134.702 177.883 133.841 177.022 132.778 177.022C131.716 177.022 130.855 177.883 130.855 178.946C130.855 180.008 131.716 180.869 132.778 180.869C133.841 180.869 134.702 180.008 134.702 178.946Z"
              fill="#005574"
            />
            <path
              d="M160.35 178.946C160.35 177.883 159.489 177.022 158.427 177.022C157.364 177.022 156.503 177.883 156.503 178.946C156.503 180.008 157.364 180.869 158.427 180.869C159.489 180.869 160.35 180.008 160.35 178.946Z"
              fill="#005574"
            />
            <path
              d="M175.74 178.946C175.74 177.883 174.879 177.022 173.816 177.022C172.754 177.022 171.893 177.883 171.893 178.946C171.893 180.008 172.754 180.869 173.816 180.869C174.879 180.869 175.74 180.008 175.74 178.946Z"
              fill="#005574"
            />
            <path
              d="M68.0153 184.074C68.0153 183.011 67.154 182.15 66.0916 182.15C65.0292 182.15 64.168 183.011 64.168 184.074C64.168 185.136 65.0292 185.997 66.0916 185.997C67.154 185.997 68.0153 185.136 68.0153 184.074Z"
              fill="#005574"
            />
            <path
              d="M73.1442 184.074C73.1442 183.011 72.2829 182.15 71.2205 182.15C70.1581 182.15 69.2969 183.011 69.2969 184.074C69.2969 185.136 70.1581 185.997 71.2205 185.997C72.2829 185.997 73.1442 185.136 73.1442 184.074Z"
              fill="#005574"
            />
            <path
              d="M78.2747 184.074C78.2747 183.011 77.4134 182.15 76.351 182.15C75.2886 182.15 74.4274 183.011 74.4274 184.074C74.4274 185.136 75.2886 185.997 76.351 185.997C77.4134 185.997 78.2747 185.136 78.2747 184.074Z"
              fill="#005574"
            />
            <path
              d="M83.4043 184.074C83.4043 183.011 82.5431 182.15 81.4807 182.15C80.4183 182.15 79.557 183.011 79.557 184.074C79.557 185.136 80.4183 185.997 81.4807 185.997C82.5431 185.997 83.4043 185.136 83.4043 184.074Z"
              fill="#005574"
            />
            <path
              d="M88.534 184.074C88.534 183.011 87.6728 182.15 86.6104 182.15C85.548 182.15 84.6867 183.011 84.6867 184.074C84.6867 185.136 85.548 185.997 86.6104 185.997C87.6728 185.997 88.534 185.136 88.534 184.074Z"
              fill="#005574"
            />
            <path
              d="M93.6637 184.074C93.6637 183.011 92.8025 182.15 91.7401 182.15C90.6777 182.15 89.8164 183.011 89.8164 184.074C89.8164 185.136 90.6777 185.997 91.7401 185.997C92.8025 185.997 93.6637 185.136 93.6637 184.074Z"
              fill="#005574"
            />
            <path
              d="M114.182 184.074C114.182 183.011 113.321 182.15 112.259 182.15C111.196 182.15 110.335 183.011 110.335 184.074C110.335 185.136 111.196 185.997 112.259 185.997C113.321 185.997 114.182 185.136 114.182 184.074Z"
              fill="#005574"
            />
            <path
              d="M119.312 184.074C119.312 183.011 118.451 182.15 117.389 182.15C116.326 182.15 115.465 183.011 115.465 184.074C115.465 185.136 116.326 185.997 117.389 185.997C118.451 185.997 119.312 185.136 119.312 184.074Z"
              fill="#005574"
            />
            <path
              d="M134.702 184.074C134.702 183.011 133.841 182.15 132.778 182.15C131.716 182.15 130.855 183.011 130.855 184.074C130.855 185.136 131.716 185.997 132.778 185.997C133.841 185.997 134.702 185.136 134.702 184.074Z"
              fill="#005574"
            />
            <path
              d="M144.962 184.074C144.962 183.011 144.101 182.15 143.038 182.15C141.976 182.15 141.114 183.011 141.114 184.074C141.114 185.136 141.976 185.997 143.038 185.997C144.101 185.997 144.962 185.136 144.962 184.074Z"
              fill="#005574"
            />
            <path
              d="M155.221 184.074C155.221 183.011 154.359 182.15 153.297 182.15C152.235 182.15 151.373 183.011 151.373 184.074C151.373 185.136 152.235 185.997 153.297 185.997C154.359 185.997 155.221 185.136 155.221 184.074Z"
              fill="#005574"
            />
            <path
              d="M175.74 184.074C175.74 183.011 174.879 182.15 173.816 182.15C172.754 182.15 171.893 183.011 171.893 184.074C171.893 185.136 172.754 185.997 173.816 185.997C174.879 185.997 175.74 185.136 175.74 184.074Z"
              fill="#005574"
            />
            <path
              d="M180.87 184.074C180.87 183.011 180.008 182.15 178.946 182.15C177.884 182.15 177.022 183.011 177.022 184.074C177.022 185.136 177.884 185.997 178.946 185.997C180.008 185.997 180.87 185.136 180.87 184.074Z"
              fill="#005574"
            />
            <path
              d="M45.5635 19.9109H25.0444C22.2113 19.9109 19.9147 22.2076 19.9147 25.0407V45.5598C19.9147 48.3929 22.2113 50.6895 25.0444 50.6895H45.5635C48.3966 50.6895 50.6933 48.3929 50.6933 45.5598V25.0407C50.6933 22.2076 48.3966 19.9109 45.5635 19.9109Z"
              stroke="#00A9E7"
              stroke-width="4.5142"
            />
            <path
              d="M30.1736 27.9768H40.4334C41.6441 27.9768 42.6256 28.9585 42.6258 30.1691V40.4289C42.6258 41.6397 41.6443 42.6213 40.4334 42.6213H30.1736C28.963 42.6211 27.9813 41.6396 27.9813 40.4289V30.1691C27.9815 28.9586 28.9631 27.977 30.1736 27.9768Z"
              fill="#00A9E7"
              stroke="#00A9E7"
              stroke-width="0.744917"
            />
            <path
              d="M178.955 19.9109H158.436C155.603 19.9109 153.306 22.2076 153.306 25.0407V45.5598C153.306 48.3929 155.603 50.6895 158.436 50.6895H178.955C181.788 50.6895 184.085 48.3929 184.085 45.5598V25.0407C184.085 22.2076 181.788 19.9109 178.955 19.9109Z"
              stroke="#00A9E7"
              stroke-width="4.5142"
            />
            <path
              d="M163.565 27.9768H173.825C175.036 27.9768 176.017 28.9585 176.017 30.1691V40.4289C176.017 41.6397 175.036 42.6213 173.825 42.6213H163.565C162.354 42.6211 161.373 41.6396 161.373 40.4289V30.1691C161.373 28.9586 162.355 27.977 163.565 27.9768Z"
              fill="#00A9E7"
              stroke="#00A9E7"
              stroke-width="0.744917"
            />
            <path
              d="M45.5635 153.302H25.0444C22.2113 153.302 19.9147 155.598 19.9147 158.431V178.95C19.9147 181.783 22.2113 184.08 25.0444 184.08H45.5635C48.3966 184.08 50.6933 181.783 50.6933 178.95V158.431C50.6933 155.598 48.3966 153.302 45.5635 153.302Z"
              stroke="#00A9E7"
              stroke-width="4.5142"
            />
            <path
              d="M30.1736 161.37H40.4334C41.6441 161.37 42.6256 162.352 42.6258 163.563V173.823C42.6258 175.033 41.6443 176.015 40.4334 176.015H30.1736C28.963 176.015 27.9813 175.033 27.9813 173.823V163.563C27.9815 162.352 28.9631 161.371 30.1736 161.37Z"
              fill="#00A9E7"
              stroke="#00A9E7"
              stroke-width="0.744917"
            />
            <path
              d="M116.42 126.515C121.996 126.515 126.514 121.994 126.514 116.422V87.8777C126.514 82.3033 121.996 77.7852 116.42 77.7852H87.8786C82.3052 77.7852 77.7842 82.3033 77.7842 87.8777V116.422C77.7842 121.994 82.3052 126.515 87.8786 126.515H116.42Z"
              fill="#00A9E7"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M98.9558 101.412C101.634 107.116 104.181 112.342 105.94 115.731C107.159 117.932 108.423 119.019 110.009 119.245C110.536 119.303 111.054 119.266 111.591 119.148C104.369 123.893 99.3067 119.968 97.9128 118.238C95.4799 115.202 92.5165 110.546 90.3065 105.65C92.0952 104.718 94.3009 103.694 96.337 102.692L98.9558 101.412ZM116.836 107.747C117.599 111.238 117.097 113.034 116.384 114.514C115.698 115.888 114.862 116.807 113.598 117.637C112.441 118.318 111.438 118.581 110.356 118.463C110.845 117.204 110.781 115.527 109.414 112.365C112.101 110.99 114.59 109.428 116.836 107.747ZM91.4632 109.416C92.8488 112.095 94.402 114.593 96.0912 116.838C92.5928 117.592 90.8127 117.09 89.3133 116.379C87.9462 115.702 87.0229 114.872 86.1989 113.594C85.505 112.448 85.2591 111.442 85.3708 110.366C86.6344 110.839 88.3219 110.775 91.4632 109.416ZM119.145 92.2538C123.896 99.4566 119.963 104.53 118.237 105.912C115.203 108.358 110.536 111.322 105.661 113.53C104.718 111.75 103.681 109.538 102.692 107.498L101.413 104.885C107.111 102.205 112.344 99.6589 115.731 97.9078C117.927 96.6751 119.011 95.411 119.247 93.8294C119.304 93.2944 119.269 92.7865 119.145 92.2538ZM98.175 90.3069C98.7699 91.4361 99.3977 92.7359 100.031 94.0497L100.348 94.7071C100.612 95.2547 100.876 95.8001 101.139 96.3322L102.413 98.9524C96.7213 101.633 91.4841 104.177 88.1071 105.933C85.9116 107.17 84.8193 108.412 84.5924 110.015C84.5365 110.538 84.561 111.052 84.7016 111.584C79.9347 104.382 83.8652 99.3016 85.5892 97.9201C88.6338 95.4769 93.2993 92.5226 98.175 90.3069ZM105.916 85.6025C108.35 88.6402 111.327 93.2946 113.536 98.1802C111.735 99.1202 109.53 100.145 107.506 101.14L104.887 102.426C102.21 96.7268 99.6496 91.4882 97.8903 88.1052C96.6737 85.908 95.4035 84.8181 93.8197 84.5986C93.2992 84.5265 92.7933 84.5644 92.2562 84.6915C99.466 79.936 104.53 83.8761 105.916 85.6025ZM93.4705 85.3751C92.9993 86.6426 93.0658 88.3154 94.4246 91.4689C91.7463 92.8567 89.239 94.4097 86.9939 96.0931C86.2505 92.6044 86.7459 90.8085 87.4651 89.3241C88.1401 87.9665 88.9642 87.0294 90.2466 86.2071C91.3993 85.5174 92.3945 85.2597 93.4705 85.3751ZM107.741 87.0026C111.242 86.2512 113.026 86.7486 114.519 87.4614C115.88 88.1364 116.82 88.9703 117.632 90.2469C118.324 91.3947 118.575 92.3923 118.462 93.4745C117.2 92.9988 115.523 93.0575 112.359 94.416C110.98 91.7484 109.443 89.2488 107.741 87.0026Z"
              fill="white"
            />
          </svg>
        </div>

        <p className="text-sm font-semibold text-gray-800 mb-2 text-left">
          Scan the QR code to download the Solidarity Drive app.
        </p>
        <p className="text-sm text-gray-500 mb-6 text-left">
          Use the same mobile number to log in and start earning points!
        </p>

        <button onClick={goHome} className="bg-sky-400 hover:bg-sky-500 transition text-black px-4 py-2 rounded-lg w-full flex justify-center items-center gap-2 font-semibold">
          View Your Policy Details <Home className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default Success;
